import { Image } from 'primereact/image';
import { InputSwitch } from "primereact/inputswitch";

import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import Layout from "../../components/common/nav/initiator/nav.component";
import { Button } from 'primereact/button';
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { DataTable } from 'primereact/datatable';
import { Auth, DataStore, Predicates, SortDirection } from 'aws-amplify';
import { ValidateInitiatorRole, } from '../../helper/validateRole';
import { Column } from 'primereact/column';
import { Sidebar } from 'primereact/sidebar';
import { Tag } from 'primereact/tag';
import sideBarRight from "../../assets/images/sidebarright.svg"
import user1 from "../../assets/images/user1.svg"
import user2 from "../../assets/images/user2.svg"
import Editpopup from "../../components/popup/editpopup";
import { Dialog } from "primereact/dialog";
import Login from '../../setup/auth/login.component';
import sidebar from "../../assets/images/sidebarright.svg"
import { Dropdown } from 'primereact/dropdown';
import pdfImage from '../../assets/images/pdfImage.png'
import pdfImageForEdit from '../../assets/images/pdfImageForEdit.png';
import pdfImageReport from '../../assets/images/pdfImageReport.png';
import { Avatar } from 'primereact/avatar';
import { FilterMatchMode, } from 'primereact/api';
import { ConvertResponseForSelectWithRefCodedropdown, ConvertResponseForSelect } from '../../helper/commonfunctions';
import {
  Schools, Subject,
  SixthPeriodAssignmentInitiateReport,
  SixthPeriodReportTransactionCycle,
  ClassifiedSubInitiateRequest, CertificatedAdminWeeklyAbsenceReportStatus,

} from "../../models";
import { groupBy, orderBy, range } from 'lodash';

import moment from "moment";
import { Link, useNavigate } from 'react-router-dom';
import AWS from "aws-sdk";
import awsmobile from "../../aws-exports";
import { Calendar } from 'primereact/calendar';
import empDetailsImg from '../../assets/images/applicationImg.png';
import { toast } from 'react-toastify';
import { Request_Status } from '../../helper/enum';
import { reactLocalStorage } from 'reactjs-localstorage';
import HtmlToPdf from '../../components/HtmlToPdf';
import { TabPanel, TabView } from 'primereact/tabview';
import { USER_TYPES, USER_TYPES_NAMES } from "../../helper/enum";
import { RadioButton } from 'primereact/radiobutton';


const ClassifiedSubstituteRequestReportList = () => {


  //initiate  new request states
  const [assignmentTitle, setAssignmentTitle] = useState('');
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [typeOfSubReqOrObjCodeValue, setTypeOfSubReqOrObjCodeValue] = useState(null);
  const [totalWorkingHoursValue, setTotalWorkingHoursValue] = useState('');
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [locationList, setLocationList] = useState([]);
  const [location, setLocation] = useState('');
  const [reasonForAbsenceReqValue, setReasonForAbsenceReqValue] = useState('');
  const [substituteValue, setSubstituteValue] = useState('');
  const [approvalOneList, setApprovalOneList] = useState([]);
  const [firstApproval, setFirstApproval] = useState(null);


  const typeOfSubReqOrObjCodeList = [
    {
      "name": "Code 1",
      "code": 'code1'
    },
    {
      "name": "Code 2",
      "code": 'code2'
    },
    {
      "name": "Code 3",
      "code": 'code3'
    }
  ]


  const [accountNoArray, setAccountNoArray] = useState([{
    "accountNo": ""
  }]);

  const [confirmedValue, seConfirmedValue] = useState('');

  const [sixPeriodIsInitiator, setSixPeriodIsInitiator] = useState(0);
  const [sixPeriodIsApprover, setSixPeriodIsApprover] = useState(0);
  const [sixPeriodIsPayroll, setSixPeriodIsPayroll] = useState(0);

  //states start
  const [selectedEmployeeForApprovals, setSelectedEmployeeForApprovals] = useState(null);
  const [selectedReportingManagerEmployee, setSelectedReportingManagerEmployee] = useState(null);

  const [allEmployeeDetails, setAllEmployeeDetails] = useState([]);
  const [selectedEmployeeDetails, setSelectedEmployeeDetails] = useState(null);
  const [empCodeList, setEmpCodeList] = useState([]);
  const [empCodeListForRM, setEmpCodeListForRM] = useState([]);

  const [specificReportDetailsView, setSpecificReportDetailsView] = useState([]);
  const [specificReportDetailsEdit, setSpecificReportDetailsEdit] = useState([]);

  console.log('specificReportDetailsEdit:-', specificReportDetailsEdit)

  //count and active index states
  const [activeIndex, setActiveIndex] = useState(0);
  const [submitCount, setSubmitCount] = useState(0);
  const [approvedCount, setApprovedCount] = useState(0);
  const [rejectCount, setRejectCount] = useState(0);
  const [pendingForApprovalCountForReqReportsCount, setPendingForApprovalCountForReqReports] = useState(0);
  const [approvedCountForReqReportsCount, setApprovedCountForReqReports] = useState(0);
  const [rejectCountForReqReportsCount, setRejectCountForReqReports] = useState(0);

  //report list
  const [initiatorReportList, setInitiatorReportList] = useState([]);
  const [approvalReportRequestList, setApprovalReportRequest] = useState([]);


  console.log("initiatorReportList", initiatorReportList);

  const [fullViewEdit, setFullViewEdit] = useState(false);
  const [fullViewForView, setFullViewForView] = useState(false);

  const [visibleCreteReportPopup, setVisibleCreteReportPopup] = useState(false);
  const [showNextPopUp, setShowNextPopUp] = useState(false);
  const [confirmVisible2, setConfirmVisible2] = useState(false);
  const [showPreviewPopUp, setShowPreviewPopUp] = useState(false);
  const [groupName, setGroupName] = useState();
  const [accountCharge, setAccountCharged] = useState('');
  const [totalStaffingAllocationectedRole, setTotalStaffingAllocation] = useState('');
  const [subjectCode, setSubjectCodeList] = useState(null);
  const [employeeId, setEmployeeId] = useState('');
  const [fteUtilized, setFteUtilized] = useState('');
  //------------


  const [checked, setChecked] = useState(false);
  const [myaccountt, setProducts] = useState([]);
  const [isAuthenticated, userHasAuthenticated] = useState(true);
  const [visible, setVisible] = useState(false);

  const [visibleEdit, setVisibleEdit] = useState(false);
  const [visibleRequestedReportEdit, setVisibleRequestedReportEdit] = useState(false);
  const [checkedSignature, setCheckedSignature] = useState(false);
  const [needMoreApprovals, setNeedMoreApprovals] = useState(false);
  const [signature, setSignature] = useState(true);

  const [showNeedMoreApprovals, setShowNeedMoreApprovals] = useState(false);

  const [rejectVisible, setRejectVisible] = useState(false);
  const [rejectMsgValue, setRejectValueMsg] = useState('');
  const [sendMsg, setSendMsg] = useState(false);


  const [confirmVisible, setConfirmVisible] = useState(false);
  const [requestApprovalConfirmVisible, setRequestApprovalConfirmVisible] = useState(false);
  const [position, setPosition] = useState('center');
  const [visibleRight, setVisibleRight] = useState(false);


  const [activate, setActivate] = useState("");

  //footer Content code start
  const footerContent = (
    <div className='text-center'>
      <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { setConfirmVisible(false); setVisibleEdit(false) }}>Close</button>
    </div>
  );
  const footerContent1 = (
    <div className='text-center'>
      <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { setConfirmVisible2(false); setShowNextPopUp(false); setVisibleCreteReportPopup(false); setShowPreviewPopUp(false); }}>Close</button>
    </div>
  );
  const footerContentForReqApproval = (
    <div className='text-center'>
      <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => { BindList(); setRequestApprovalConfirmVisible(false); setVisibleRequestedReportEdit(false) }}>Close</button>
    </div>
  );
  const footerContentForReqReject = () => (
    <div className='text-center'>
      <div className="mb-10 px-5 py-3 flex gap-2 justify-center">
        {
          (sendMsg) ?
            <button
              className='bg-[#113699] border bJorder-[##113699] text-white px-8 py-2 rounded'
              onClick={() => {
                BindList();setRejectVisible(false);
                setVisibleRequestedReportEdit(false);
                setSendMsg(false);
              }}
            >Ok</button> :


            <button
              className='bg-[#113699] border border-[##113699] text-white px-8 py-2 rounded'
              onClick={() => rejectSelectedReport(specificReportDetailsEdit.id)}
            >Send</button>
        }
        <button
          onClick={() => setRejectVisible(false)}
          className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
        >
          <i className="gusd-close-circle mr-1" style={{ fontSize: '1rem' }}></i>
          Cancel
        </button>
      </div>
    </div>
  );
  //footer Content code end

  //*state
  const [reportId, setReportId] = useState('');
  const [schoolName, setSchoolName] = useState('');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [status, setStatus] = useState('');
  const [schoolList, setSchoolList] = useState('');
  const [schoolSelect, setSelectedSchool] = useState('');


  //*List
  const [employeeList, setEmployeeList] = useState([]);
  const [reportEmployeeList, setReportEmployeeList] = useState([]);
  const [users, SetUsersList] = useState([]);


  const [absentCodeListDropdown, setSubjectListDropdown] = useState();
  const loggedUserId = reactLocalStorage.get('loggedUserId');

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [classificationValue, setClassificationValue] = useState('');

  //edit form props fields

  const [editMode, setEditMode] = useState(false);
  const [editRequestID, setEditRequestID] = useState('');

  const [propsAssighnmentTitle, setPropsAssighnmentTitle] = useState('');
  const [propsSelectedEmployee, setPropsSelectedEmployee] = useState('');
  const [propsReportingManagerEmployee, setPropsReportingManagerEmployee] = useState('');
  const [propsSchoolSelect, setPropsSchoolSelect] = useState('');
  const [propsStartDate, setPropsStartDate] = useState('');
  const [propsSubjectCode, setPropsSubjectCode] = useState('');
  const [propsTotalStaffingAllocationectedRole, setPropsTotalStaffingAllocationectedRole] = useState('');
  const [propsAccountCharge, setPropsAccountCharge] = useState('');
  const [propsFteUtilized, setPropsFteUtilized] = useState('');
  const [propsEndDate, setPropsEndDate] = useState('');
  const [currentStatus, setCurrentStatus] = useState('');

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    assignmentTitle: { value: null, matchMode: FilterMatchMode.CONTAINS },
    period: { value: null, matchMode: FilterMatchMode.CONTAINS },
    submittedOn: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
    remark: { value: null, matchMode: FilterMatchMode.CONTAINS },

  });

  const [statuses] = useState(['Approved', 'Pending', 'Rejected', 'Submitted', 'Reviewed & resubmitted']);

  //status format and layout code start
  const TaskStatusSL = (product) => {
    switch (product.status) {
      case 'Reviewed & resubmitted':
        return 'info';

      case 'Rejected':
        return 'danger';

      case 'Pending':
        return 'warning';

      case 'Submitted':
        return 'info';

      case 'Approved':
        return 'success';

      case 'Approved (P)':
        return 'success';

      default:
        return null;
    }
  };
  const TaskStatusSLA = (product) => {
    // console.log("product", product.status);
    return <Tag value={product.status} severity={TaskStatusSL(product)}></Tag>;
  };
  const requestReportStatusOptions = (product) => {

    switch (product.status) {
      case 'Rejected':
        return 'danger';

      case 'Pending for Approval':
        return 'warning';

      case 'SUBMITTED':
        return 'info';
      case 'Approved':
        return 'success';

      default:
        return null;
    }
  };
  const approveStatusOptions = (product) => {

    switch (product.status) {
      case 'Rejected':
        return 'danger';

      case 'Pending For Approval':
        return 'warning';

      case 'Closed':
        return 'success';
      case 'Approved':
        return 'success';
        case 'Submitted':
          return 'info';
      default:
        return null;
    }
  };
  const requestReportStatus = (product) => {
    return <Tag value={product.status} severity={requestReportStatusOptions(product)}></Tag>;
  };
  const approvalStatusBody = (product) => {
    return <Tag value={product.status} severity={approveStatusOptions(product)}></Tag>;
  };
  //status format and layout code end

  const onClickHandleEdit = async (requestData, currentstatus) => {
    setPropsAssighnmentTitle('')
    setPropsSelectedEmployee('')
    setPropsReportingManagerEmployee('')
    setPropsSchoolSelect('')
    setPropsStartDate('')
    setPropsSubjectCode()
    setPropsTotalStaffingAllocationectedRole('')
    setPropsAccountCharge('')
    setPropsFteUtilized('')
    setEditMode(true)
    setEditRequestID(requestData.id)
    setCurrentStatus(currentstatus)

    //create form empty data set
    setAssignmentTitle("")
    setSelectedEmployee("")
    setSelectedReportingManagerEmployee("")
    setSelectedSchool("")
    setStartDate("")
    setEndDate("")
    setSubjectCodeList("")
    setTotalStaffingAllocation("")
    setAccountCharged("")
    setFteUtilized("")

    if (requestData) {
      console.log(requestData)

      //set manager data employee
      var newRes = []
      let userRole = '', userName = '', userEmail = '', userCode = '', userReportingManager = '',sub='';

      console.log("usersusersusers:-", users)

      users.forEach((user, i) => {
        userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
        userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
        userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
        userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
        userReportingManager = user.Attributes.find(attr => attr.Name === "custom:SPReportingManager")?.Value;
        sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
        let obj = {
          "userId": sub,
          "name": userName,
          "email": userEmail,
          "usercode": userCode,
          "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
          "userReportingManager": userReportingManager
        }
        newRes.push(obj);
      }
      );

      //get only those users are without admin
      let usersWithoutAdmin = [];
      const loggedUserId = reactLocalStorage.get('loggedUserId');
      console.log("INITIATE loggedUserIdloggedUserId:-", loggedUserId)

      console.log('INITIATE newResnewResnewRes:-', newRes)

      newRes.map((currentItem) => {
        if (currentItem.role !== 'Admin'
          && currentItem.userId !== loggedUserId) {
          usersWithoutAdmin.push(currentItem);
        }
      })

      console.log("INITIATE usersWithoutAdminusersWithoutAdmin:-", usersWithoutAdmin)
      //set employee list
      let finalEmpList = [];

      usersWithoutAdmin.map((currentItem) => {
        let obj = { name: currentItem.usercode + '(' + currentItem.name + ')', code: currentItem.userId };
        finalEmpList.push(obj);
      })
      setEmpCodeList(finalEmpList);
      setAllEmployeeDetails(usersWithoutAdmin);



      const cognito = new AWS.CognitoIdentityServiceProvider();
      let employeeUser;
      if (requestData.employeeCode) {
        try {
          employeeUser = await cognito.adminGetUser({
            UserPoolId: awsmobile.aws_user_pools_id,
            Username: requestData.employeeCode,
          }).promise();
        } catch (e) {
          //console.log(e)
        }
      }

      let managerUser;

      let managerUserId = employeeUser ? employeeUser.UserAttributes.find(attr => attr.Name === "custom:SPReportingManager") : ''
      managerUserId = managerUserId ? managerUserId.Value : ''
      //console.log(managerUserId)
      if (managerUserId) {
        try {
          managerUser = await cognito.adminGetUser({
            UserPoolId: awsmobile.aws_user_pools_id,
            Username: managerUserId,
          }).promise();
        } catch (e) {
          //console.log(e)
        }
      }

      let managerName = managerUser ? managerUser.UserAttributes.find(attr => attr.Name === "name") : ''
      let managerusercode = managerUser ? managerUser.UserAttributes.find(attr => attr.Name === "custom:userCode") : ''
      managerusercode = managerusercode ? managerusercode.Value : ''

      let newEmpForRM = [];
      console.log(finalEmpList)
      for (let i = 0; i < finalEmpList.length; i++) {
        if (finalEmpList[i].code === requestData.employeeCode) {
          continue;
        } else {
          newEmpForRM.push(finalEmpList[i]);


        }
      }


      setEmpCodeListForRM(newEmpForRM)
      //set selected id employee data
      usersWithoutAdmin.map((currentItem) => {
        if (currentItem.userId === requestData.employeeCode) {
          setSelectedEmployeeDetails(currentItem);
          if (currentItem.userReportingManager) {
            finalEmpList.map((currentItems) => {

              if (currentItems.code === currentItem.userReportingManager) {
                setPropsReportingManagerEmployee(currentItems);

              }
            })
          } else {
            setPropsReportingManagerEmployee(null);
          }

          console.log("currentItemcurrentItemcurrentItem:-", currentItem)
        }
      })



      let employeeName = employeeUser ? employeeUser.UserAttributes.find(attr => attr.Name === "name") : ''
      let usercode = employeeUser ? employeeUser.UserAttributes.find(attr => attr.Name === "custom:userCode") : ''
      usercode = usercode ? usercode.Value : ''
      console.log(requestData)
      let getSchool = await DataStore.query(Schools, (c) => c.name.eq(requestData.assignmentAt))
      console.log(getSchool)
      let schooll = getSchool && getSchool.length ? { code: getSchool[0].id, name: getSchool[0].name } : ''

      var SubjectCodeResponses = await DataStore.query(Subject, (c) => c.name.eq(requestData.subjectData));
      let subjectt = SubjectCodeResponses && SubjectCodeResponses.length ? { code: SubjectCodeResponses[0].id, name: SubjectCodeResponses[0].name } : ''
      console.log(SubjectCodeResponses[0])
      //console.log(usercode + '(' + employeeName.Value + ')')
      setPropsAssighnmentTitle(requestData.assignmentTitle)
      setPropsSelectedEmployee({ code: requestData.employeeCode, name: employeeName ? usercode + '(' + employeeName.Value + ')' : '' })
      setSelectedEmployee({ code: requestData.employeeCode, name: employeeName ? usercode + '(' + employeeName.Value + ')' : '' })
      if (managerUserId) {

        //setPropsReportingManagerEmployee({  name: managerName ? managerusercode + '(' + managerName.Value + ')' : ''  ,code: managerUserId })
        //setSelectedReportingManagerEmployee({  name: managerName ? managerusercode + '(' + managerName.Value + ')' : ''  ,code: managerUserId })
      }

      console.log({ code: managerUserId, name: managerName ? managerusercode + '(' + managerName.Value + ')' : '' })
      setPropsSchoolSelect(schooll)
      setPropsStartDate(requestData.fromDate)
      setPropsEndDate(requestData.toDate)
      setPropsSubjectCode(subjectt)
      setSubjectCodeList("")
      setPropsTotalStaffingAllocationectedRole(requestData.totalStaffAllocation)
      setPropsAccountCharge(requestData.accountCharged)
      setPropsFteUtilized(requestData.currentFTEUtilized)

      setShowNextPopUp(true)
    }

  }
  //action layout code start
  const initiateReportAction = (row) => {
    return (
      <div className="flex justify-center w-full gap-2" >

        {
          row.status === "Submitted" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickHandleEdit(row, "Submitted")}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
            row.status === "Pending" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickHandleEdit(row, "Pending")}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
              row.status === "Approved" ? <Link to='#' className="py-2 px-2.5" onClick={() => onClickInitiateRequestViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                row.status === "Rejected" ? <Link to='#' className="py-2 px-2.5"
                  onClick={() =>
                    onClickHandleEdit(row, "Rejected")
                  }
                ><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link> :
                  <Link to='#' className="py-2 px-2.5"
                    onClick={() =>
                      onClickInitiateRequestViewPopup(row, 'right')
                      //onClickInitiateRequestEditPopUp(row)
                    }><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link>
        }
      </div>
    );
  };



  const requestedReportAction = (row) => {
    return (
      <div className="flex justify-center w-full gap-2">


        {
          row.status === 'Pending for Approval' ?
            <Link to='' className="py-2 px-2.5"
              // onClick={() => { setVisibleRight(true); onClickPopup(row); }}
              onClick={() =>
                onClickRequestedReportEditPopUp(row)
              }
            ><i className="gusd-edit text-[18px] text-[#667085] font-meduim"></i></Link> :
            row.status === 'Approved' ?
              <Link to='' className="py-2 px-2.5" onClick={() => onClickRequestedReportViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
              row.status === 'Rejected' ?
                <Link to='' className="py-2 px-2.5" onClick={() => onClickRequestedReportViewPopup(row, 'right')}><i className="gusd-eye text-[#667085] text-[20px] font-meduim"></i></Link> :
                null
        }
      </div >
    );
  };
  //action layout code end




  //* onclick view popup
  const onClickInitiateRequestViewPopup = async (requestData, position) => {

    console.log('APPP Initiate view requestData:-', requestData)
    console.log('APPP Initiate view users:-', users);

    //fetch user data
    var newRes = []
    let userRole = '', userName = '', userEmail = '', userCode = '',sub='';
    console.log('APPP user4:-', users)
    users.forEach((user, i) => {

      userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
      userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
      userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
      userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
      sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
      let obj = {
        "userId": sub,
        "name": userName,
        "email": userEmail,
        "usercode": userCode,
        "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
      }
      newRes.push(obj);
    }
    );

    console.log("APPP newResnewRes:-", newRes)

    let empData = [];

    for (let i = 0; i < newRes.length; i++) {
      const currentItem = newRes[i];

      if (currentItem.userId === requestData.employeeCode) {
        empData.push(currentItem);
        break;
      }
    }
    //---------------

    //---Start Approval Status-----
    //get particular report id data from transaction cycle.
    let approvalFinalData = [];
    try {
      const particularReportTransactionCycleResponse = await DataStore.query(SixthPeriodReportTransactionCycle, (c) => c.report_Id.eq(requestData.id));
      console.log("APPPP particularReportTransactionCycleResponse 11:-", particularReportTransactionCycleResponse);
      console.log("APPPP particularReportTransactionCycleResponse users 12:-", newRes);

      if (particularReportTransactionCycleResponse) {
        //get name of user from 'to_Employee_Id'
        for (let i = 0; i < particularReportTransactionCycleResponse.length; i++) {
          let empName = '', empCode = '';

          for (let j = 0; j < newRes.length; j++) {
            let currentItem = newRes[j];
            if (currentItem.userId == particularReportTransactionCycleResponse[i].to_Employee_Id) {
              empName = currentItem.name;
              empCode = currentItem.usercode;
              break;
            }
          }

          let obj = {
            empName: empName,
            empCode: empCode,
            status: ((particularReportTransactionCycleResponse[i].status) === "Open") ? 'Pending For Approval' : particularReportTransactionCycleResponse[i].status
          }

          approvalFinalData.push(obj);
        }
      }

    } catch (err) {
      console.log("Error in onClickInitiateRequestViewPopup", err);
    }
    //---End Approval Status-------





    setPosition(position);
    setVisible(true);

    //set Data for View Popup
    let obj = {
      employeeName: empData[0].name,
      employee_id: empData[0].usercode,
      assighment_at: requestData.assignmentAt,
      from_date: requestData.fromDate,
      to_date: requestData.toDate,
      subject_area: requestData.subjectData,
      total_staffing_allocation: requestData.totalStaffAllocation,
      account_charged: requestData.accountCharged,
      current_fte_utilized: requestData.currentFTEUtilized,

      approvalFinalData: approvalFinalData
    }
    setSpecificReportDetailsView(obj);
  }
  const onClickInitiateRequestEditPopUp = async (requestData) => {


    //fetch user data
    var newRes = []
    let userRole = '', userName = '', userEmail = '', userCode = '',sub='';
    console.log('APPP user4:-', users)
    users.forEach((user, i) => {

      userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
      userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
      userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
      userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
      sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
      let obj = {
        "userId": sub,
        "name": userName,
        "email": userEmail,
        "usercode": userCode,
        "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
      }
      newRes.push(obj);
    }
    );

    console.log("APPP newResnewRes:-", newRes)


    //---Start Approval Status-----
    //get particular report id data from transaction cycle.
    let approvalFinalData = [];
    try {
      const particularReportTransactionCycleResponse = await DataStore.query(SixthPeriodReportTransactionCycle, (c) => c.report_Id.eq(requestData.id));
      console.log("APPPP particularReportTransactionCycleResponse 11:-", particularReportTransactionCycleResponse);
      console.log("APPPP particularReportTransactionCycleResponse users 12:-", newRes);

      if (particularReportTransactionCycleResponse) {
        //get name of user from 'to_Employee_Id'
        for (let i = 0; i < particularReportTransactionCycleResponse.length; i++) {
          let empName = '', empCode = '';

          for (let j = 0; j < newRes.length; j++) {
            let currentItem = newRes[j];
            if (currentItem.userId == particularReportTransactionCycleResponse[i].to_Employee_Id) {
              empName = currentItem.name;
              empCode = currentItem.usercode;
              break;
            }
          }

          let obj = {
            empName: empName,
            empCode: empCode,
            status: ((particularReportTransactionCycleResponse[i].status) === "Open") ? 'Pending For Approval' : particularReportTransactionCycleResponse[i].status
          }

          approvalFinalData.push(obj);
        }
      }

    } catch (err) {
      console.log("Error in onClickInitiateRequestEditPopUp", err);
    }
    //---End Approval Status-------



    let empData = [];

    for (let i = 0; i < newRes.length; i++) {
      const currentItem = newRes[i];

      if (currentItem.userId === requestData.employeeCode) {
        empData.push(currentItem);
        break;
      }
    }
    //---------------


    setVisibleEdit(true)

    //set Data for View Popup
    //set Data for View Popup
    let obj = {
      id: requestData.id,
      empID: requestData.employeeCode,
      employeeName: empData[0].name,
      employee_id: empData[0].usercode,
      assighment_at: requestData.assignmentAt,
      from_date: requestData.fromDate,
      to_date: requestData.toDate,
      subject_area: requestData.subjectData,
      total_staffing_allocation: requestData.totalStaffAllocation,
      account_charged: requestData.accountCharged,
      current_fte_utilized: requestData.currentFTEUtilized,

      approvalFinalData: approvalFinalData
    }
    setSpecificReportDetailsEdit(obj);

  }

  //onclick requested report popups
  //onclick edit poup
  const onClickRequestedReportEditPopUp = async (requestData) => {

    //fetch user data
    var newRes = []
    let userRole = '', userName = '', userEmail = '', userCode = '',sub='';
    console.log('APPP user4:-', users)
    users.forEach((user, i) => {

      userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
      userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
      userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
      userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
      sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
      let obj = {
        "userId": sub,
        "name": userName,
        "email": userEmail,
        "usercode": userCode,
        "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
      }
      newRes.push(obj);
    }
    );
    console.log("APPP newResnewRes:-", newRes);


    //---Start Approval Status-----
    //get particular report id data from transaction cycle.
    let approvalFinalData = [];
    try {
      const particularReportTransactionCycleResponse = await DataStore.query(SixthPeriodReportTransactionCycle, (c) => c.report_Id.eq(requestData.id));
      console.log("APPPP particularReportTransactionCycleResponse 11:-", particularReportTransactionCycleResponse);
      console.log("APPPP particularReportTransactionCycleResponse users 12:-", newRes);

      if (particularReportTransactionCycleResponse) {
        //get name of user from 'to_Employee_Id'
        for (let i = 0; i < particularReportTransactionCycleResponse.length; i++) {
          let empName = '', empCode = '';

          for (let j = 0; j < newRes.length; j++) {
            let currentItem = newRes[j];
            if (currentItem.userId == particularReportTransactionCycleResponse[i].to_Employee_Id) {
              empName = currentItem.name;
              empCode = currentItem.usercode;
              break;
            }
          }

          let obj = {
            empName: empName,
            empCode: empCode,
            status: ((particularReportTransactionCycleResponse[i].status) === "Open") ? 'Pending For Approval' : particularReportTransactionCycleResponse[i].status
          }

          approvalFinalData.push(obj);
        }
      }

    } catch (err) {
      console.log("Error in onClickInitiateRequestEditPopUp", err);
    }
    //---End Approval Status-------

    let empData = [];

    for (let i = 0; i < newRes.length; i++) {
      const currentItem = newRes[i];

      if (currentItem.userId === requestData.employeeCode) {
        empData.push(currentItem);
        break;
      }
    }
    //---------------

    console.log("APPP empData:-", empData)

    setVisibleRequestedReportEdit(true);

    //get selected report id 
    //set Data for View Popup
    let obj = {
      id: requestData.id,
      employeeName: empData[0].name,
      employee_id: empData[0].usercode,
      assighment_at: requestData.assignmentAt,
      from_date: requestData.fromDate,
      to_date: requestData.toDate,
      subject_area: requestData.subjectData,
      total_staffing_allocation: requestData.totalStaffAllocation,
      account_charged: requestData.accountCharged,
      current_fte_utilized: requestData.currentFTEUtilized,

      approvalFinalData: approvalFinalData
    }
    setSpecificReportDetailsEdit(obj);

    //check specific report =>transaction cycle length is greter than 3
    try {
      //check for reviewresubmitted in transaction cycle
      let sixthPeriodReportTransactionCycleResponseLate = await DataStore.query(SixthPeriodReportTransactionCycle,
        (c) => c.report_Id.eq(requestData.id), { sort: (s) => s.createdAt(SortDirection.DESCENDING) });



      //let previousREviewResubmitted = sixthPeriodReportTransactionCycleResponseLate.length ? sixthPeriodReportTransactionCycleResponseLate[0] : 0
      // if(previousREviewResubmitted){

      // }
      //1.fetch those request which initiate by logged user
      const sixthPeriodReportTransactionCycleResponse = await DataStore.query(SixthPeriodReportTransactionCycle,
        (c) => c.report_Id.eq(requestData.id));
      if (sixthPeriodReportTransactionCycleResponse.length >= 3) {
        setNeedMoreApprovals(true);
      }
      console.log(sixthPeriodReportTransactionCycleResponse)

      //loop to get last status

      if (sixthPeriodReportTransactionCycleResponse.length >= 3) {
        let countCycle = false;
        for (let i = 0; i < 3; i++) {
          if (sixthPeriodReportTransactionCycleResponseLate[i].status === "ReviewedResubmitted") {
            if (i === 2) {
              setNeedMoreApprovals(true)
              countCycle = true
            } else {
              setNeedMoreApprovals(false)
              setSignature(false)
              setCheckedSignature(true)
            }
          }

        }


        let reviewList = sixthPeriodReportTransactionCycleResponseLate.filter(item => item.status === "ReviewedResubmitted");
        if (reviewList.length >= 1) {
          //setSignature(false)
          //setCheckedSignature(true)
        }


        if (countCycle) {
          setSignature(true)
          setCheckedSignature(false)
        }
      }


    } catch (err) {
      console.log("ERROR in request Edit function");
    }


  }
  //* onclick view popup
  const onClickRequestedReportViewPopup = async (requestData, position) => {

    //fetch user data
    var newRes = []
    let userRole = '', userName = '', userEmail = '', userCode = '',sub='';
    console.log('APPP user4:-', users)
    users.forEach((user, i) => {

      userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
      userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
      userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
      userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
      sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
      let obj = {
        "userId": sub,
        "name": userName,
        "email": userEmail,
        "usercode": userCode,
        "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
      }
      newRes.push(obj);
    }
    );

    console.log("APPP newResnewRes:-", newRes)

    //---Start Approval Status-----
    //get particular report id data from transaction cycle.
    let approvalFinalData = [];
    let formHistoryFinalData = [];
    try {
      const particularReportTransactionCycleResponse = await DataStore.query(SixthPeriodReportTransactionCycle, (c) => c.report_Id.eq(requestData.id));
      console.log("APPPP particularReportTransactionCycleResponse 11:-", particularReportTransactionCycleResponse);
      console.log("APPPP particularReportTransactionCycleResponse users 12:-", newRes);

      if (particularReportTransactionCycleResponse) {
        //get name of user from 'to_Employee_Id'
        for (let i = 0; i < particularReportTransactionCycleResponse.length; i++) {
          let empName = '', empCode = '';

          for (let j = 0; j < newRes.length; j++) {
            let currentItem = newRes[j];
            if (currentItem.userId == particularReportTransactionCycleResponse[i].to_Employee_Id) {
              empName = currentItem.name;
              empCode = currentItem.usercode;
              break;
            }
          }

          let obj = {
            empName: empName,
            empCode: empCode,
            status: ((particularReportTransactionCycleResponse[i].status) === "Open") ? 'Pending For Approval' : particularReportTransactionCycleResponse[i].status
          }

          //form history remark 
          if (particularReportTransactionCycleResponse[i].status === 'Rejected') {

            let obj = {
              empName: empName,
              remarkType: 'Rejected',
              empRemark: particularReportTransactionCycleResponse[i].remark
            };

            formHistoryFinalData.push(obj);
          }

          approvalFinalData.push(obj);
        }
      }

    } catch (err) {
      console.log("Error in onClickInitiateRequestViewPopup", err);
    }
    //---End Approval Status-------


    let empData = [];

    for (let i = 0; i < newRes.length; i++) {
      const currentItem = newRes[i];

      if (currentItem.userId === requestData.employeeCode) {
        empData.push(currentItem);
        break;
      }
    }
    //---------------


    setPosition(position);
    setVisible(true);

    //set Data for View Popup
    let obj = {
      employeeName: empData[0].name,
      employee_id: empData[0].usercode,
      assighment_at: requestData.assignmentAt,
      from_date: requestData.fromDate,
      to_date: requestData.toDate,
      subject_area: requestData.subjectData,
      total_staffing_allocation: requestData.totalStaffAllocation,
      account_charged: requestData.accountCharged,
      current_fte_utilized: requestData.currentFTEUtilized,

      approvalFinalData: approvalFinalData,
      formHistoryFinalData: formHistoryFinalData

    }
    setSpecificReportDetailsView(obj);
  }


  const toggleActive = () => {
    setActivate(activate === "actives" ? "" : "actives");
  };

  async function onLoad() {
    try {
      await Auth.currentSession();
      if (!ValidateInitiatorRole()) { userHasAuthenticated(false); }
    } catch (e) {
      userHasAuthenticated(false);
    }
  }


  const saveBasicEditInfo = async (type, currentStatus) => {

    // if (assignmentTitle === '') { toast.error('Please enter Assighment Title'); return; }
    // else if (selectedEmployee === null) { toast.error('Please Select Employee Id'); return; }
    // else if (schoolSelect === '') { toast.error('Please Select Assignment At'); return; }
    // else if (startDate === null) { toast.error('Please enter From Date'); return; }
    // else if (endDate === null) { toast.error('Please enter To Date'); return; }
    // else if (subjectCode === null) { toast.error('Please enter To Date'); return; }

    //Save Basic Info

    // console.log(subjectCode && subjectCode.name ? subjectCode.name : propsSubjectCode.name);
    // console.log(schoolSelect && schoolSelect.name ? schoolSelect.name : propsSchoolSelect.name);
    // return
    //check type
    if (type === 'save') {
      const original = await DataStore.query(SixthPeriodAssignmentInitiateReport, editRequestID)
      await DataStore.save(
        SixthPeriodAssignmentInitiateReport.copyOf(original, (updated) => {
          updated.assignment_title = assignmentTitle ? assignmentTitle : propsAssighnmentTitle;
          updated.employee_id = selectedEmployee && selectedEmployee.code ? selectedEmployee.code : propsSelectedEmployee.code;
          updated.assighment_at = schoolSelect && schoolSelect.name ? schoolSelect.name : propsSchoolSelect.name;
          updated.from_date = startDate ? moment(startDate).format("YYYY-MM-DD") : moment(propsStartDate).format("YYYY-MM-DD");
          updated.to_date = endDate ? moment(endDate).format("YYYY-MM-DD") : moment(propsEndDate).format("YYYY-MM-DD");
          updated.subject_area = subjectCode && subjectCode.name ? subjectCode.name : propsSubjectCode.name;
          updated.total_staffing_allocation = totalStaffingAllocationectedRole ? totalStaffingAllocationectedRole : propsTotalStaffingAllocationectedRole;
          updated.account_charged = accountCharge ? accountCharge : propsAccountCharge;
          updated.current_fte_utilized = fteUtilized ? fteUtilized : propsFteUtilized;
          updated.created_by = loggedUserId;
          updated.particular_emp_reporting_manager = propsReportingManagerEmployee ? propsReportingManagerEmployee.code : selectedReportingManagerEmployee.code;

        })
      );


      //first save report in SixthPeriodAssignmentInitiateReport table
      //var newSixthPeriodAssignmentInitiateReport = await DataStore.save(new SixthPeriodAssignmentInitiateReport({

      // "status": Request_Status.P,
      //})
      //);

      //second add first report transaction entry in SixthPeriodReportTransactionCycle table
      // if (newSixthPeriodAssignmentInitiateReport) {

      //console.log("newSixthPeriodAssignmentInitiateReport:-", newSixthPeriodAssignmentInitiateReport.id)


      try {
        var newSixthPeriodReportTransactionCycle = await DataStore.save(new SixthPeriodReportTransactionCycle({
          "report_Id": editRequestID,
          "from_Employee_Id": loggedUserId,
          "to_Employee_Id": selectedEmployee && selectedEmployee.code ? selectedEmployee.code : propsSelectedEmployee.code,
          "status": currentStatus === "Rejected" ? "ReviewedResubmitted" : 'Submitted',
          "isApproved": false,
          "remark": '',
          "date": moment().format("YYYY-MM-DD"),
        }))

        if (newSixthPeriodReportTransactionCycle) {

          //BindList();
        }

      } catch (err) {
        console.log("Error in reviewedAndResubmit:-", err)
      }


      toast.success('The report updated successfully for reviewed and resubmit.');

      BindList();
      setShowNextPopUp(false);
      //}


    } else {
      //other wise status submit

      // try {

      ////first save report in SixthPeriodAssignmentInitiateReport table
      // var newSixthPeriodAssignmentInitiateReport = await DataStore.save(new SixthPeriodAssignmentInitiateReport({
      // "assignment_title": assignmentTitle,
      // "employee_id": selectedEmployee.code,
      // "assighment_at": schoolSelect.name,
      // "from_date": moment(startDate).format("YYYY-MM-DD"),
      // "to_date": moment(endDate).format("YYYY-MM-DD"),
      // "subject_area": subjectCode.name,
      // "total_staffing_allocation": totalStaffingAllocationectedRole,
      // "account_charged": accountCharge,
      // "current_fte_utilized": fteUtilized,
      // "submited_by": loggedUserId,
      // "created_by": loggedUserId,
      // "submited_at": moment().format("YYYY-MM-DD"),
      // "particular_emp_reporting_manager": selectedReportingManagerEmployee.code
      // })
      // );

      ////second add first report transaction entry in SixthPeriodReportTransactionCycle table
      // if (newSixthPeriodAssignmentInitiateReport) {

      // console.log("newSixthPeriodAssignmentInitiateReport:-", newSixthPeriodAssignmentInitiateReport.id)


      // var newSixthPeriodReportTransactionCycle = await DataStore.save(new SixthPeriodReportTransactionCycle({
      // "report_Id": newSixthPeriodAssignmentInitiateReport.id,
      // "from_Employee_Id": loggedUserId,
      // "to_Employee_Id": selectedEmployee.code,
      // "status": 'Open',
      // "isApproved": false,
      // "remark": '',
      // "date": moment().format("YYYY-MM-DD"),
      // }))

      // if (newSixthPeriodAssignmentInitiateReport && newSixthPeriodReportTransactionCycle) {
      // toast.success('Data Added Successfully for Submitted.');
      // BindList();
      // }

      // }



      // } catch (err) {
      // console.log("Error in saveBasicInfo on submit code", err);
      // }
    }
  }

  const saveBasicInfo = async (type) => {

    if (assignmentTitle === '') { toast.error('Please enter Assighment Title'); return; }
    else if (selectedEmployee === null && selectedEmployee == '') { toast.error('Please Select Employee Id'); return; }
    else if (classificationValue === '') { toast.error('Please Enter Classification Value'); return; }
    else if (startDate === null) { toast.error('Please select Start Date'); return; }
    else if (endDate === null) { toast.error('Please enter End Date'); return; }
    else if (typeOfSubReqOrObjCodeValue === null) { toast.error('Please select type of sub req code'); return; }
    else if (totalWorkingHoursValue === '') { toast.error('Please enter total work hours'); return; }
    else if (startTime === null) { toast.error('Please select start time'); return; }
    else if (endTime === null) { toast.error('Please select End time'); return; }
    else if (location === null) { toast.error('Please select location'); return; }
    else if (reasonForAbsenceReqValue === '') { toast.error('Please enter reason for Absence'); return; }
    else if (substituteValue === '') { toast.error('Please enter Substitute'); return; }
    else if (confirmedValue === '') { toast.error('Please Confirm'); return; }
    else if (firstApproval === null) { toast.error('Please Select Approval'); return; }


    //Save Basic Info
    //check type
    if (type === 'save') {

      console.log("startTimestartTime:-",startTime);
      console.log("startTimestartTime N:-",moment(startTime).format("HH-mm-ss"));
      // return 0;

      //first save report in ClassifiedSubInitiateRequest table
      var newClassifiedSubInitiateRequest = await DataStore.save(new ClassifiedSubInitiateRequest({
        "assignment_title": assignmentTitle,
        "classification": classificationValue,
        "selectedEmployeeId": selectedEmployee.code,
        "fromDate": moment(startDate).format("YYYY-DD-MM"),
        "toDate": moment(endDate).format("YYYY-DD-MM"),
        "typeOfSubReqOrobjCode": typeOfSubReqOrObjCodeValue.code,
        "totalWorkingHours": totalWorkingHoursValue,
        "startTime": moment(startTime).format("HH-mm-ss"),
        "endTime": moment(endTime).format("HH-mm-ss"),
        "locationId": location.code,
        "reasonForAbsenceRequest": reasonForAbsenceReqValue,
        "substitude": substituteValue,
        "confirmed": (confirmedValue == 'Yes') ? true : false,

        "firstApproverId":firstApproval.code
      })
      );

      //second add first report transaction entry in SixthPeriodReportTransactionCycle table
      if (newClassifiedSubInitiateRequest) {

        console.log("newClassifiedSubInitiateRequest:-", newClassifiedSubInitiateRequest.id)

        toast.success('Data Added Successfully for pending.');

        BindList();
        setShowNextPopUp(false);
      }


    } else {
      //other wise status submit

      try {

        //first save report in SixthPeriodAssignmentInitiateReport table
        var newSixthPeriodAssignmentInitiateReport = await DataStore.save(new SixthPeriodAssignmentInitiateReport({
          "assignment_title": assignmentTitle,
          "employee_id": selectedEmployee.code,
          "assighment_at": schoolSelect.name,
          "from_date": moment(startDate).format("YYYY-MM-DD"),
          "to_date": moment(endDate).format("YYYY-MM-DD"),
          "subject_area": subjectCode.name,
          "total_staffing_allocation": totalStaffingAllocationectedRole,
          "account_charged": accountCharge,
          "current_fte_utilized": fteUtilized,
          "submited_by": loggedUserId,
          "created_by": loggedUserId,
          "submited_at": moment().format("YYYY-MM-DD"),
          "particular_emp_reporting_manager": selectedReportingManagerEmployee.code
        })
        );

        //second add first report transaction entry in SixthPeriodReportTransactionCycle table
        if (newSixthPeriodAssignmentInitiateReport) {

          console.log("newSixthPeriodAssignmentInitiateReport:-", newSixthPeriodAssignmentInitiateReport.id)


          var newSixthPeriodReportTransactionCycle = await DataStore.save(new SixthPeriodReportTransactionCycle({
            "report_Id": newSixthPeriodAssignmentInitiateReport.id,
            "from_Employee_Id": loggedUserId,
            "to_Employee_Id": selectedEmployee.code,
            "status": 'Open',
            "isApproved": false,
            "remark": '',
            "date": moment().format("YYYY-MM-DD"),
          }))

          if (newSixthPeriodAssignmentInitiateReport && newSixthPeriodReportTransactionCycle) {
            toast.success('Data Added Successfully for Submitted.');
            BindList();
          }

        }



      } catch (err) {
        console.log("Error in saveBasicInfo on submit code", err);
      }
    }
  }

  //onSubmitFunction 
  const onSubmitFunction = async (reportId, employeeID) => {
    console.log("reportIdreportId 1:-", reportId);
    console.log("reportIdreportId 2:-", employeeID);

    try {
      var newSixthPeriodReportTransactionCycle = await DataStore.save(new SixthPeriodReportTransactionCycle({
        "report_Id": reportId,
        "from_Employee_Id": loggedUserId,
        "to_Employee_Id": employeeID,
        "status": 'Reviewed & resubmitted',
        "isApproved": false,
        "remark": '',
        "date": moment().format("YYYY-MM-DD"),
      }))

      if (newSixthPeriodReportTransactionCycle) {
        // toast.success('Data Added Successfully for Submitted.');
        BindList();
      }

    } catch (err) {
      console.log("Error in reviewedAndResubmit:-", err)
    }


  }



  AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_AccessKeyId,
    secretAccessKey: process.env.REACT_APP_AWS_SecretAccessKey,
    region: process.env.REACT_APP_AWS_Region,
  });

  const loadUsers = () => {
    //------------------------------- load users-------------
    const cognito = new AWS.CognitoIdentityServiceProvider();
    var params =
    {
      UserPoolId: awsmobile.aws_user_pools_id,
      Limit: 60
    };
    cognito.listUsers(params, (err, data) => {
      if (err) {
        console.log(err);
      } else {
        // console.log(data)
        SetUsersList(data.Users);



        var newRes = []
        let userRole = '', userName = '', userEmail = '', userCode = '',sub='';
        (data.Users).forEach((user, i) => {
          userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
          userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
          userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
          userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
          sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
          let obj = {
            "userId": sub,
            "name": userName,
            "email": userEmail,
            "usercode": userCode,
            "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
          }
          newRes.push(obj);
        }
        );



        //get only those users are without admin
        let usersWithoutAdminAndLoggedUser = [];
        const loggedUserId = reactLocalStorage.get('loggedUserId');


        newRes.map((currentItem) => {
          if (currentItem.role !== 'Admin'
            && currentItem.userId !== loggedUserId) {
            usersWithoutAdminAndLoggedUser.push(currentItem);
          }
        })

        //set employee list
        let finalEmployeeList = [{ name: "No Approval Needed", code: 'no_approval_needed' }];
        let finalFirstApproverList = [];

        usersWithoutAdminAndLoggedUser.map((currentItem) => {
          let obj = { name: currentItem.name, code: currentItem.userId };
          finalEmployeeList.push(obj);
          finalFirstApproverList.push(obj);
        })
        setEmployeeList(finalEmployeeList);
        setApprovalOneList(finalFirstApproverList);

      }
    });
    //-------------------------------------------------------
  }

  const BindList = async () => {


    // const loggedUserId = reactLocalStorage.get('loggedUserId');

    // try {

    //   //1.fetch those request which initiate by logged user
    //   const sixPeriodInitiatorReportResponse = await DataStore.query(SixthPeriodAssignmentInitiateReport,
    //     (c) => c.created_by.eq(loggedUserId),
    //     Predicates.ALL, {
    //     sort: s => s.assignment_title(SortDirection.ASCENDING)
    //   });
    //   if (sixPeriodInitiatorReportResponse) {

    //     console.log("APPP sixPeriodInitiatorReportResponse iiiii :- pdf", sixPeriodInitiatorReportResponse)

    //     let finalInitiateRequestData = [];
    //     let submitCount = 0;
    //     let approvedCount = 0;
    //     let rejectCount = 0;

    //     let lent = sixPeriodInitiatorReportResponse.length

    //     for (let i = 0; i < sixPeriodInitiatorReportResponse.length; i++) {
    //       const currentItem = sixPeriodInitiatorReportResponse[i];



    //       const startDate = new Date(currentItem.from_date);
    //       const endDate = new Date(currentItem.to_date);
    //       const dateFormatter = new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
    //       const formattedStartDate = dateFormatter.format(startDate);
    //       const formattedEndDate = dateFormatter.format(endDate);
    //       const period = `${formattedStartDate} to ${formattedEndDate}`;
    //       let status = (currentItem.submited_by) ? 'Submitted' : 'Pending';
    //       let remark = '-';



    //       //get specific currentItem.id transaction cycle report data
    //       const sixthPeriodReportTransactionCycleResponse = await DataStore.query(SixthPeriodReportTransactionCycle, (c) => c.report_Id.eq(currentItem.id));
    //       for (let i = 0; i < sixthPeriodReportTransactionCycleResponse.length; i++) {
    //         if (sixthPeriodReportTransactionCycleResponse[i].status === "Closed") {
    //           status = "Approved";
    //           break;
    //         }
    //       }

    //       for (let i = 0; i < sixthPeriodReportTransactionCycleResponse.length; i++) {
    //         if (sixthPeriodReportTransactionCycleResponse[i].remark) {
    //           remark = sixthPeriodReportTransactionCycleResponse[i].remark;
    //           status = "Rejected";
    //         }
    //       }
    //       for (let i = 0; i < sixthPeriodReportTransactionCycleResponse.length; i++) {
    //         if (sixthPeriodReportTransactionCycleResponse[i].status === 'ReviewedResubmitted') {
    //           // remark = sixthPeriodReportTransactionCycleResponse[i].remark;
    //           status = "Reviewed & resubmitted";
    //         }
    //       }

    //       //console.log(sixthPeriodReportTransactionCycleResponse)



    //       //---------------------------------------------------------



    //       let obj = {
    //         id: currentItem.id,
    //         srNo: lent - i,    //i + 1,
    //         assignmentTitle: currentItem.assignment_title,
    //         period: period,
    //         submittedOn: currentItem.submited_at ? moment(currentItem.submited_at, 'YYYY-MM-DD').format('MM/DD/YYYY') : '-', //currentItem.submited_at,
    //         status: status,
    //         remark: remark,

    //         //data for pdf 
    //         employeeName: 'Empoyee NAme',
    //         employeeCode: currentItem.employee_id,
    //         assignmentAt: currentItem.assighment_at,
    //         toDate: currentItem.to_date,
    //         fromDate: currentItem.from_date,
    //         subjectData: currentItem.subject_area,
    //         totalStaffAllocation: currentItem.total_staffing_allocation,
    //         accountCharged: currentItem.account_charged,
    //         currentFTEUtilized: currentItem.current_fte_utilized
    //       };

    //       //specific report category get approved,submitted and rejected count

    //       if (status === 'Submitted') {
    //         submitCount++;
    //       } else if (status === 'Approved') {
    //         approvedCount++;
    //       } else if (status === 'Rejected') {
    //         rejectCount++;
    //       }



    //       finalInitiateRequestData.push(obj);
    //     }
    //     finalInitiateRequestData.reverse();
    //     setInitiatorReportList(finalInitiateRequestData);

    //     setSubmitCount(submitCount);
    //     setApprovedCount(approvedCount);
    //     setRejectCount(rejectCount);
    //   }



    //   //2.fetch those request which needs approval for logged users.
    //   let sixthPeriodReportTransactionCycleResponse = await DataStore.query(SixthPeriodReportTransactionCycle, (c) => c.to_Employee_Id.eq(loggedUserId), { sort: (s) => s.createdAt(SortDirection.DESCENDING) });
    //   console.log("APPPP sixthPeriodReportTransactionCycleResponse nnn:-", sixthPeriodReportTransactionCycleResponse);
    //   sixthPeriodReportTransactionCycleResponse = groupBy(sixthPeriodReportTransactionCycleResponse, 'report_Id');
    //   if (sixthPeriodReportTransactionCycleResponse) {

    //     let pendingCount = 0;
    //     let approvedCount = 0;
    //     let rejectCount = 0;
    //     let approvalFinalData = [];
    //     let i = 0;
    //     // for (let i = 0; i < sixthPeriodReportTransactionCycleResponse.length; i++) {
    //     for (let report_Id in sixthPeriodReportTransactionCycleResponse) {
    //       const currentItem = sixthPeriodReportTransactionCycleResponse[report_Id][0];

    //       //get Report data using report id 
    //       const sixthPeriodReportResponse = await DataStore.query(SixthPeriodAssignmentInitiateReport, (c) => c.id.eq(report_Id));
    //       console.log("APPPP report resp 11" + report_Id + " ", sixthPeriodReportResponse)

    //       const sixthPeriodReportTransactionCycleResponseNew = await DataStore.query(SixthPeriodReportTransactionCycle, (c) => c.report_Id.eq(report_Id), { sort: (s) => s.createdAt(SortDirection.DESCENDING) });
    //       console.log("APPPP report resp transaction 22" + report_Id + " ", sixthPeriodReportTransactionCycleResponseNew)


    //       // const sixthPeriodReportTransactionCycleResponseNew2 = await DataStore.query(SixthPeriodReportTransactionCycle,
    //       // (c) => c.and(c => [
    //       // c.report_Id.eq(report_Id),
    //       // c.status.eq("ReviewedResubmitted")
    //       // ])
    //       // ,{ sort: (s) => s.createdAt(SortDirection.DESCENDING) });
    //       // console.log("APPPP report resp  2244" + i + " ", sixthPeriodReportTransactionCycleResponseNew2)



    //       const startDate = new Date(sixthPeriodReportResponse[0].from_date);
    //       const endDate = new Date(sixthPeriodReportResponse[0].to_date);
    //       const dateFormatter = new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'short', year: 'numeric' });
    //       const formattedStartDate = dateFormatter.format(startDate);
    //       const formattedEndDate = dateFormatter.format(endDate);
    //       const period = `${formattedStartDate} to ${formattedEndDate}`;
    //       let status = (currentItem.isApproved) ? 'Approved' : (currentItem.remark) ? 'Rejected' : 'Pending for Approval';
    //       let remark = (currentItem.remark) ? currentItem.remark : "-";

    //       // if (sixthPeriodReportTransactionCycleResponseNew) {
    //       //     for (let i = 0; i < sixthPeriodReportTransactionCycleResponseNew.length; i++) {

    //       //         // if(){

    //       //         // }


    //       //         if (sixthPeriodReportTransactionCycleResponseNew[i].remark) {
    //       //             remark = sixthPeriodReportTransactionCycleResponseNew[i].remark;
    //       //             status = "Rejected";
    //       //         }
    //       //     }
    //       // }


    //       let obj = {
    //         id: sixthPeriodReportResponse[0].id,
    //         srNo: i + 1,
    //         assignmentTitle: sixthPeriodReportResponse[0].assignment_title,
    //         period: period,
    //         submittedOn: sixthPeriodReportResponse[0].submited_at,
    //         status: status,
    //         remark: remark,

    //         //data for pdf 
    //         // employeeName: 'Empoyee NAme',
    //         employeeCode: sixthPeriodReportResponse[0].employee_id,
    //         assignmentAt: sixthPeriodReportResponse[0].assighment_at,
    //         toDate: sixthPeriodReportResponse[0].to_date,
    //         fromDate: sixthPeriodReportResponse[0].from_date,
    //         subjectData: sixthPeriodReportResponse[0].subject_area,
    //         totalStaffAllocation: sixthPeriodReportResponse[0].total_staffing_allocation,
    //         accountCharged: sixthPeriodReportResponse[0].account_charged,
    //         currentFTEUtilized: sixthPeriodReportResponse[0].current_fte_utilized
    //       };

    //       //specific report category get approved,submitted and rejected count
    //       //count for 

    //       // const sixthPeriodReportTransactionCycleResponseNew2 = await DataStore.query(SixthPeriodReportTransactionCycle,
    //       // (c) => c.and(c => [
    //       // c.report_Id.eq(report_Id),
    //       // c.status.eq("ReviewedResubmitted")
    //       // ])
    //       if (status === 'Pending For Approval') {
    //         pendingCount++;
    //       } else if (status === 'Approved') {
    //         approvedCount++;
    //       } else if (status === 'Rejected') {
    //         rejectCount++;
    //       }

    //       approvalFinalData.push(obj);
    //       i = i + 1
    //     }

    //     //approvalFinalData.reverse();

    //     setPendingForApprovalCountForReqReports(pendingCount);
    //     setApprovedCountForReqReports(approvedCount);
    //     setRejectCountForReqReports(rejectCount);
    //     setApprovalReportRequest(approvalFinalData);
    //   }


    // } catch (err) {
    //   console.log("Error in BindList Function." + err)
    // }


    // var SubjectCodeResponses = await DataStore.query(Subject, Predicates.ALL, {
    //   sort: s => s.name(SortDirection.ASCENDING)
    // });
    // setSubjectCodeList(SubjectCodeResponses)
    // var myArray = []; myArray = ConvertResponseForSelectWithRefCodedropdown(SubjectCodeResponses); setSubjectListDropdown(myArray);

    var schoolListResponse = await DataStore.query(Schools, Predicates.ALL, {
      sort: s => s.name(SortDirection.ASCENDING)
    });
    var schoolArray = []; schoolArray = ConvertResponseForSelect(schoolListResponse); setLocationList(schoolArray);
  }

  //initiate new report
  const initiateNewReport = async () => {

    //set edit data empty	
    // setPropsAssighnmentTitle('')
    // setPropsSelectedEmployee('')
    // setPropsReportingManagerEmployee('')
    // setPropsSchoolSelect('')
    // setPropsStartDate('')
    // setPropsEndDate('')
    // setPropsSubjectCode()
    // setPropsTotalStaffingAllocationectedRole('')
    // setPropsAccountCharge('')
    // setPropsFteUtilized('')
    // setEditMode(false)
    // setEditRequestID('')
    // setCurrentStatus("")

    //empty form
    // setAssignmentTitle("")
    // setSelectedEmployee("")
    // setSelectedReportingManagerEmployee("")
    // setSelectedSchool("")
    // setStartDate("")
    // setEndDate("")
    // setSubjectCodeList("")
    // setTotalStaffingAllocation("")
    // setAccountCharged("")
    // setFteUtilized("")


    var newRes = []
    let userRole = '', userName = '', userEmail = '', userCode = '', userReportingManager = '',sub='';

    console.log("usersusersusers:-", users)

    users.forEach((user, i) => {
      userRole = user.Attributes.find(attr => attr.Name === "custom:role")?.Value;
      userName = user.Attributes.find(attr => attr.Name === "name")?.Value;
      userEmail = user.Attributes.find(attr => attr.Name === "email")?.Value;
      userCode = user.Attributes.find(attr => attr.Name === "custom:userCode")?.Value;
      userReportingManager = user.Attributes.find(attr => attr.Name === "custom:SPReportingManager")?.Value;
      sub = user.Attributes.find(attr => attr.Name === "sub")?.Value;
      let obj = {
        "userId": sub,
        "name": userName,
        "email": userEmail,
        "usercode": userCode,
        "role": userRole === USER_TYPES.ADMIN ? USER_TYPES_NAMES.A : userRole === USER_TYPES.APPROVER ? USER_TYPES_NAMES.AP : userRole === USER_TYPES.PAYROLL ? USER_TYPES_NAMES.P : USER_TYPES_NAMES.I,
        "userReportingManager": userReportingManager
      }
      newRes.push(obj);
    }
    );

    //get only those users are without admin
    let usersWithoutAdmin = [];
    const loggedUserId = reactLocalStorage.get('loggedUserId');
    console.log("INITIATE loggedUserIdloggedUserId:-", loggedUserId)

    console.log('INITIATE newResnewResnewRes:-', newRes)

    newRes.map((currentItem) => {
      if (currentItem.role !== 'Admin'
        && currentItem.userId !== loggedUserId) {
        usersWithoutAdmin.push(currentItem);
      }
    })

    console.log("INITIATE usersWithoutAdminusersWithoutAdmin:-", usersWithoutAdmin)
    //set employee list
    let finalEmpList = [];

    usersWithoutAdmin.map((currentItem) => {
      let obj = { name: currentItem.usercode + '(' + currentItem.name + ')', code: currentItem.userId };
      finalEmpList.push(obj);
    })
    setEmpCodeList(finalEmpList);
    setAllEmployeeDetails(usersWithoutAdmin);

    setShowNextPopUp(true);
  }

  //onSelect particular employye
  const selectedEmployeeFunction = async (e) => {

    //remove specific employee from list
    let newEmpForRM = [];
    for (let i = 0; i < empCodeList.length; i++) {
      if (empCodeList[i].code === e.value.code) {
        continue;
      } else {
        newEmpForRM.push(empCodeList[i]);
      }
    }


    setEmpCodeListForRM(newEmpForRM);

    setSelectedEmployee(e.value);
    //set selected id employee data
    allEmployeeDetails.map((currentItem) => {
      if (currentItem.userId === e.value.code) {
        setSelectedEmployeeDetails(currentItem);

        if (currentItem.userReportingManager) {
          empCodeList.map((currentItems) => {
            if (currentItems.code === currentItem.userReportingManager) {
              setSelectedReportingManagerEmployee(currentItems);
            }
          })
        } else {
          setSelectedReportingManagerEmployee(null);
        }

        console.log("currentItemcurrentItemcurrentItem:-", currentItem)
      }
    })


  }



  //approve report function
  const approveSelectedReport = async (reportId) => {
    console.log('APPP approveSelectedReport reportId:-', reportId)

    const loggedUserId = reactLocalStorage.get("loggedUserId");

    // const SPReportingManager = reactLocalStorage.get("SPReportingManager");
    //get reporting manager from SixthPeriodAssignmentInitiateReport table
    try {
      const sixthPeriodAssignmentInitiateReport = await DataStore.query(SixthPeriodAssignmentInitiateReport, (c) => c.id.eq(reportId));
      console.log("APPP approveSelectedReport specificReportData", sixthPeriodAssignmentInitiateReport)

      if (sixthPeriodAssignmentInitiateReport) {
        const original = await DataStore.query(SixthPeriodReportTransactionCycle, (c) => c.report_Id.eq(reportId), {
          sort: (s) => s.createdAt(SortDirection.ASCENDING)
        });
        console.log("APPP approveSelectedReport original", original);

        // return 0;


        if (original.length > 1) {
          if (selectedEmployeeForApprovals) {
            if (selectedEmployeeForApprovals.code === "no_approval_needed") {

              //-----------------
              let newOriginal = [];

              for (let i = 0; i < original.length; i++) {
                let currentItem = original[i];

                if (currentItem.to_Employee_Id === loggedUserId) {
                  newOriginal.push(currentItem);
                  break;
                }
              }
              //-----------------

              const newNextOriginalN1 = await DataStore.query(SixthPeriodReportTransactionCycle, (c) => c.report_Id.eq(reportId), {
                sort: (s) => s.createdAt(SortDirection.DESCENDING)
              });

              await DataStore.save(
                SixthPeriodReportTransactionCycle.copyOf(newNextOriginalN1[0], (updated) => {
                  updated.isApproved = true;
                  updated.status = 'Closed';
                })
              ).then(async () => {
                setRequestApprovalConfirmVisible(true);
                setCheckedSignature(false);
              })

            } else {

              //-----------------
              let newOriginal = [];

              for (let i = 0; i < original.length; i++) {
                let currentItem = original[i];

                if (currentItem.to_Employee_Id === loggedUserId) {
                  newOriginal.push(currentItem);
                  // break;
                }
              }
              //-----------------

              const newNextOriginal1 = await DataStore.query(SixthPeriodReportTransactionCycle, (c) => c.report_Id.eq(reportId), {
                sort: (s) => s.createdAt(SortDirection.DESCENDING)
              });
              await DataStore.save(
                SixthPeriodReportTransactionCycle.copyOf(newNextOriginal1[0], (updated) => {
                  updated.isApproved = true;
                  updated.status = 'Approved';
                })
              ).then(async () => {

                //after we add another row for save report id for reporting managers approver
                const addNewRowForRMReasponse = await DataStore.save(new SixthPeriodReportTransactionCycle({
                  "report_Id": reportId,
                  "from_Employee_Id": loggedUserId,
                  "to_Employee_Id": selectedEmployeeForApprovals.code,
                  "status": 'Open',
                  "isApproved": false,
                  "remark": '',
                  "date": moment().format("YYYY-MM-DD"),
                }));

                if (addNewRowForRMReasponse) {
                  setRequestApprovalConfirmVisible(true);
                  setCheckedSignature(false);
                }
              })
            }
          } else {


            let sixthPeriodReportTransactionCycleResponseLate = await DataStore.query(SixthPeriodReportTransactionCycle,
              (c) => c.report_Id.eq(reportId), { sort: (s) => s.createdAt(SortDirection.DESCENDING) });
            let setReviewSubmitt = false;
            if (sixthPeriodReportTransactionCycleResponseLate.length > 3 && sixthPeriodReportTransactionCycleResponseLate[0].status === "ReviewedResubmitted") {
              setReviewSubmitt = true;

              await DataStore.save(
                SixthPeriodReportTransactionCycle.copyOf(sixthPeriodReportTransactionCycleResponseLate[0], (updated) => {
                  updated.isApproved = true;
                  //updated.status = 'Approved';
                })
              ).then(async () => {

                //after we add another row for save report id for reporting managers approver
                const addNewRowForRMReasponse = await DataStore.save(new SixthPeriodReportTransactionCycle({
                  "report_Id": reportId,
                  "from_Employee_Id": loggedUserId,
                  "to_Employee_Id": sixthPeriodAssignmentInitiateReport[0].particular_emp_reporting_manager,
                  "status": 'Open',
                  "isApproved": false,
                  "remark": '',
                  "date": moment().format("YYYY-MM-DD"),
                }));

                if (addNewRowForRMReasponse) {
                  setRequestApprovalConfirmVisible(true);
                  setCheckedSignature(false);
                }
              })


              // if(setReviewSubmitt){
              ////sixthPeriodAssignmentInitiateReport[0].particular_emp_reporting_manager
              // }else{

              // }

            } else {

              const newNextOriginal = await DataStore.query(SixthPeriodReportTransactionCycle, (c) => c.report_Id.eq(reportId), {
                sort: (s) => s.createdAt(SortDirection.DESCENDING)
              });

              //back to initiator return

              await DataStore.save(
                SixthPeriodReportTransactionCycle.copyOf(newNextOriginal[0], (updated) => {
                  updated.isApproved = true;
                  updated.status = 'Approved';
                })
              ).then(async () => {

                //after we add another row for save report id for reporting managers approver
                const addNewRowForRMReasponse = await DataStore.save(new SixthPeriodReportTransactionCycle({
                  "report_Id": reportId,
                  "from_Employee_Id": loggedUserId,
                  "to_Employee_Id": sixthPeriodAssignmentInitiateReport[0].submited_by,
                  "status": 'Open',
                  "isApproved": false,
                  "remark": '',
                  "date": moment().format("YYYY-MM-DD"),
                }));




                if (addNewRowForRMReasponse) {
                  setRequestApprovalConfirmVisible(true);
                  setCheckedSignature(false);
                }
              })

            }


          }



        } else {


          await DataStore.save(
            SixthPeriodReportTransactionCycle.copyOf(original[0], (updated) => {
              updated.isApproved = true;
              updated.status = 'Approved';
            })
          ).then(async () => {

            //after we add another row for save report id for reporting managers approver
            const addNewRowForRMReasponse = await DataStore.save(new SixthPeriodReportTransactionCycle({
              "report_Id": reportId,
              "from_Employee_Id": loggedUserId,
              "to_Employee_Id": sixthPeriodAssignmentInitiateReport[0].particular_emp_reporting_manager,
              "status": 'Open',
              "isApproved": false,
              "remark": '',
              "date": moment().format("YYYY-MM-DD"),
            }));

            if (addNewRowForRMReasponse) {
              setRequestApprovalConfirmVisible(true);
              setCheckedSignature(false);
            }
          })
        }





      }


      return false;

      //check to employee is equal to submitted by 



      if (sixthPeriodAssignmentInitiateReport) {
        let SPReportingManager = sixthPeriodAssignmentInitiateReport[0].particular_emp_reporting_manager;

        //----------------
        try {

          const original = await DataStore.query(SixthPeriodReportTransactionCycle, (c) => c.report_Id.eq(reportId));
          console.log("originaloriginal :-", original);

          console.log("selectedEmployeeForApprovalsselectedEmployeeForApprovals:-", selectedEmployeeForApprovals)

          if (selectedEmployeeForApprovals) {

            if (selectedEmployeeForApprovals.code === "no_approval_needed") {

              //-----------------
              let newOriginal = [];

              for (let i = 0; i < original.length; i++) {
                let currentItem = original[i];

                if (currentItem.to_Employee_Id === loggedUserId) {
                  newOriginal.push(currentItem);
                  break;
                }
              }
              //-----------------


              await DataStore.save(
                SixthPeriodReportTransactionCycle.copyOf(newOriginal[0], (updated) => {
                  updated.isApproved = true;
                  updated.status = 'Closed';
                })
              ).then(async () => {
                setRequestApprovalConfirmVisible(true);
                setCheckedSignature(false);
              })

            } else {


              //-----------------
              let newOriginal = [];

              for (let i = 0; i < original.length; i++) {
                let currentItem = original[i];

                if (currentItem.to_Employee_Id === loggedUserId) {
                  newOriginal.push(currentItem);
                  break;
                }
              }
              //-----------------


              await DataStore.save(
                SixthPeriodReportTransactionCycle.copyOf(newOriginal[0], (updated) => {
                  updated.isApproved = true;
                  updated.status = 'Approved';
                })
              ).then(async () => {

                //after we add another row for save report id for reporting managers approver
                const addNewRowForRMReasponse = await DataStore.save(new SixthPeriodReportTransactionCycle({
                  "report_Id": reportId,
                  "from_Employee_Id": loggedUserId,
                  "to_Employee_Id": selectedEmployeeForApprovals.code,
                  "status": 'Open',
                  "isApproved": false,
                  "remark": '',
                  "date": moment().format("YYYY-MM-DD"),
                }));

                if (addNewRowForRMReasponse) {
                  setRequestApprovalConfirmVisible(true);
                  setCheckedSignature(false);
                }
              })
            }






          } else {
            //if logged user have reporting manager means=this is teacher then give first entry approval.
            if (SPReportingManager) {
              await DataStore.save(
                SixthPeriodReportTransactionCycle.copyOf(original[0], (updated) => {
                  updated.isApproved = true;
                  updated.status = 'Approved';
                })
              ).then(async () => {

                //after we add another row for save report id for reporting managers approver
                const addNewRowForRMReasponse = await DataStore.save(new SixthPeriodReportTransactionCycle({
                  "report_Id": reportId,
                  "from_Employee_Id": loggedUserId,
                  "to_Employee_Id": SPReportingManager,
                  "status": 'Open',
                  "isApproved": false,
                  "remark": '',
                  "date": moment().format("YYYY-MM-DD"),
                }));

                if (addNewRowForRMReasponse) {
                  setRequestApprovalConfirmVisible(true);
                  setCheckedSignature(false);
                }
              })
            } else {
              //else logged user is Reporting manager or main initiator
              // case 01:user is RM
              let newOriginal = [];

              for (let i = 0; i < original.length; i++) {
                let currentItem = original[i];

                if (currentItem.to_Employee_Id === loggedUserId) {
                  newOriginal.push(currentItem);
                  break;
                }
              }

              //get that particular report's submitted by employee which is initiator
              const originalReport = await DataStore.query(SixthPeriodAssignmentInitiateReport, (c) => c.id.eq(reportId));



              await DataStore.save(
                SixthPeriodReportTransactionCycle.copyOf(newOriginal[0], (updated) => {
                  updated.isApproved = true;
                  updated.status = 'Approved';
                })
              ).then(async () => {

                //after we add another row for save report id for reporting managers approver
                const addNewRowForRMReasponse = await DataStore.save(new SixthPeriodReportTransactionCycle({
                  "report_Id": reportId,
                  "from_Employee_Id": loggedUserId,
                  "to_Employee_Id": originalReport[0].submited_by,
                  "status": 'Open',
                  "isApproved": false,
                  "remark": '',
                  "date": moment().format("YYYY-MM-DD"),
                }));

                if (addNewRowForRMReasponse) {
                  setRequestApprovalConfirmVisible(true);
                  setCheckedSignature(false);
                }
              })

            }

          }


        } catch (err) {
          console.log("Error when Approved");
        }
        //----------------
      }
    } catch (err) {
      console.log("approveSelectedReport function while fetch report metadata", err);
    }

    // console.log("APPP SPReportingManager:-", SPReportingManager)






    // var newSixthPeriodAssignmentInitiateReport = await DataStore.save(new SixthPeriodAssignmentInitiateReport({
    //     "assignment_title": assighnmentTitle,
    //     "employee_id": selectedEmployee.name,
    //     "assighment_at": schoolSelect.name,
    //     "from_date": moment(startDate).format("YYYY-MM-DD"),
    //     "to_date": moment(endDate).format("YYYY-MM-DD"),
    //     "subject_area": subjectCode.name,
    //     "total_staffing_allocation": totalStaffingAllocationectedRole,
    //     "account_charged": accountCharge,
    //     "current_fte_utilized": fteUtilized,
    //     "status": Request_Status.P,
    // })
    // );


  }
  //reject report function
  const rejectSelectedReport = async (reportId) => {

    if (rejectMsgValue === "") { toast.error('Please Add Reason For Rejection'); return; }

    //get specific report id transaction table data and add rejected status in specific entry
    try {
      const original = await DataStore.query(SixthPeriodReportTransactionCycle, (c) => c.report_Id.eq(reportId));
      console.log("originaloriginal :-", original);

      let newOriginal = [];

      for (let i = 0; i < original.length; i++) {
        let currentItem = original[i];

        if (currentItem.to_Employee_Id === loggedUserId) {
          newOriginal.push(currentItem);
          break;
        }
      }

      await DataStore.save(
        SixthPeriodReportTransactionCycle.copyOf(newOriginal[0], (updated) => {
          updated.status = 'Rejected';
          updated.remark = rejectMsgValue;
        })
      ).then(async () => {
        setSendMsg(true);
      })




    } catch (err) {
      console.log("Error in reject specific report function")
    }
  }




  //---filter code------
  //const [filters, setFilters] = useState(null);



  //filter code end-----

  const statusItemTemplate = (option) => {

    console.log("option", option);

    return <Tag value={option} severity={TaskStatusSL(option)} />;
  };

  const checkApplicationAccessibility = async () => {
    //six-period 
    let sixPeriodIsInitiator = reactLocalStorage.get('sixPeriodIsInitiator');
    let sixPeriodIsApprover = reactLocalStorage.get('sixPeriodIsApprover');
    let sixPeriodIsPayroll = reactLocalStorage.get('sixPeriodIsPayroll');
    let sixPeriodIsSuperadmin = reactLocalStorage.get('sixPeriodIsSuperadmin');

    setSixPeriodIsInitiator(sixPeriodIsInitiator);
    setSixPeriodIsApprover(sixPeriodIsApprover);
    setSixPeriodIsPayroll(sixPeriodIsPayroll);
    setSixPeriodIsPayroll(sixPeriodIsPayroll);
  }


  //*Add Multiple acc no.
  const onClickAdd = () => {
    let data = { "accountNo": "" }
    let newData = [...accountNoArray, data];
    setAccountNoArray(newData)
  }
  //*onChange acc no.
  const onChangeAccNo = (index, value) => {
    let data = [...accountNoArray]
    data[index]["accountNo"] = value;
    setAccountNoArray(data)
  }

  useEffect(() => {
    checkApplicationAccessibility();
    loadUsers();
    BindList();
    onLoad();
  }, []);




  const statusRowFilterTemplate = (options) => {
    return (
      <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterApplyCallback(e.value)} itemTemplate={statusItemTemplate} placeholder="Select" className="p-column-filter custDropdown" showClear style={{ minWidth: '7rem' }} />
    );
  };





  return isAuthenticated ? (
    <>
      <Layout pageTitle="Report" activeMenu="Initiator" appId="CLASSIFIED_SUB_REQUEST">
        <div className="report-wrapper pt-24 md:pt-28 xl:pt-[2.083vw]">
          <div className="flex justify-end visible lg:hidden">
            <Button icon="pi pi-bars" onClick={toggleActive} style={{ color: '#308B90', background: '#ffffff00', border: '1', borderColor: '#308B90', width: '38px', padding: '6px 0', borderRadius: '4px' }}></Button>

          </div>
          <div className="grid grid-cols-1 md:grid-cols-12 gap-3 xl:gap-[1.250vw] pb-5">
            <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-3">
              <div>
                <div id={activate} className="bg-[#FFFFFF] rounded-lg box-shadow-1 radius4 p-4 xl:p-[0.833vw] top-5 lg:sticky fixed -left-96 lg:left-0 lg:overflow-hidden lg:h-auto z-10" data-aos="fade-up" data-aos-duration="800">
                  <div className="flex justify-between text-[#101828] font-medium text-base tracking-[0.02em] xl:text-[0.932vw]">
                    <p>Forms</p>
                    <div className="xl:w-[10.058vw] md:w-[200px] custinput">
                      <span className="w-full p-input-icon-left">
                        <i className="gusd-search text-[#667085] mt-0" />
                        <InputText placeholder="Search" className="w-full" />
                      </span>
                    </div>
                  </div>

                  <div className="mt-4 h-[600px] xl:h-[38vw]  overflow-auto">

                    <div className="bg-[#0F1E4C]  radius4 p-[16px] xl:p-[0.833vw]">
                      <h6 className="font-medium text-[16px] text-[#fff] xl:text-[0.833vw] mb-2">Substitute Request - Classified</h6>
                      <div className="flex justify-between gap-2 xl:gap-[0.833vw] xl:mt-[0.833vw]">
                        <div className="flex items-center gap-1">
                          <div className="bg-[#EAEFFF] text-[16px] xl:text-[0.833vw] border border-[#99B2FF] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                            {(activeIndex === 0) ? submitCount : pendingForApprovalCountForReqReportsCount}
                          </div>
                          <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">{(activeIndex === 0) ? 'Submitted' : 'Pending For Approvals'}</div>
                        </div>
                        <div className="flex items-center gap-1">
                          <div className="bg-[#D1FADF] text-[16px] xl:text-[0.833vw] border border-[#A6F4C5] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                            {(activeIndex === 0) ? approvedCount : approvedCountForReqReportsCount}
                          </div>
                          <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">Approved </div>
                        </div>
                        <div className="flex items-center gap-1">
                          <div className="bg-[#FEF3F2] text-[16px] xl:text-[0.833vw] border border-[#FEE4E2] radius4 text-[#0D256D] font-semibold xl:w-[1.927vw] xl:h-[1.250vw] w-[37px] text-center">
                            {(activeIndex === 0) ? rejectCount : rejectCountForReqReportsCount}
                          </div>
                          <div className="text-[12px] xl:text-[0.625vw] text-[#fff] font-normal">Rejected</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative z-10 col-span-12 lg:col-span-9" data-aos="fade-down" data-aos-duration="800">
              <div className="bg-[#fff] box-shadow-2 radius8 border border-[#E4E7EC]" >
                <div className="flex items-center justify-between p-[20px] xl:px-[1.250vw] xl:py-[0.990vw] border-b border-[#E4E7EC] ">
                  <p className="text-[22px] xl:text-[0.938vw]  text-[#101828] font-medium">Substitute Request - Classified</p>

                  <div className="flex gap-2 xl:gap-[0.990vw] items-center">

                    {
                      (sixPeriodIsInitiator == 1) ?
                        <Link to='#' className="w-full text-center tableBtn blue radius8" onClick={() => initiateNewReport()}>
                          <i className="gusd-pluse-circle mx-1.5 "></i> Initiate New Report
                        </Link> : null
                    }

                    <div className="relative dropcheck">
                      <Menu as="div">
                        <Menu.Button><i className="gusd-filter-1"></i></Menu.Button>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="absolute right-0 z-50 w-[100px] xl:w-[9.542vw]  origin-top-right bg-white rounded-[5px] xl:rounded-[5px] shadow-[0px_2px_2px_rgba(20, 46, 82, 0.2)]">
                            <div className="px-4 pt-5 pb-3 xl:px-[0.833vw] xl:py-[0.833vw] top-[-10px]">
                              <div className="mb-4 xl:mb-[0.417vw]">

                                <div className="flex items-center mb-2">
                                  <Checkbox onChange={e => setChecked(e.checked)} checked={checked}></Checkbox>
                                  <label htmlFor="ingredient1" className="ml-2 text-[#344054] text-[15px] font-medium xl:text-[0.900vw]">Year</label>
                                </div>
                                <div className="flex items-center mb-3">
                                  <Checkbox onChange={e => setChecked(e.checked)} checked={checked}></Checkbox>
                                  <label htmlFor="ingredient1" className="ml-2 text-[#344054] text-[15px] font-medium xl:text-[0.900vw]">Month</label>

                                </div>

                                <Link to="" className="flex justify-center bg-[#3366FF] text-[14px] text-[#fff] px-5 py-1.5  rounded-md w-full">Select</Link>

                              </div>


                            </div>

                          </Menu.Items>
                        </Transition>
                      </Menu>
                    </div>
                    <Link to=""> <i className="gusd-expand"></i></Link>
                  </div>
                </div>


                <TabView activeIndex={sixPeriodIsInitiator == 1 ? activeIndex : 1} onTabChange={(e) => setActiveIndex(e.index)}>

                  {
                    (sixPeriodIsInitiator == 1) ?
                      <TabPanel header="Initiate Reports">
                        <div className={initiatorReportList.length === 0 ? "datatableemptymessage arrowhide" : "initiator  arrowshow"}>
                          <DataTable
                            className="custpaginator custIcons custmBtnTable custTable"
                            scrollable
                            value={initiatorReportList}
                            paginator rowsPerPageOptions={[10, 20, 30]} filters={filters} filterDisplay="row" responsiveLayout="scroll" paginatorTemplate="PrevPageLink PageLinks NextPageLink" rows={11}

                            // dataKey="srNo" filters={filters} globalFilterFields={['assignmentTitle', 'submittedOn', 'status', 'remark']}
                            // header={header}
                            emptyMessage="No customers found."
                          >
                            <Column field="srNo" header="SL#" style={{ minWidth: '3rem' }}></Column>
                            {/* <Column field="assignmentTitle" header="Assignment Title"
                              filter filterPlaceholder="Search"
                              sortable style={{ minWidth: '5rem' }}></Column> */}
                            <Column field="dates" filter filterPlaceholder="Search" header="Dates" sortable></Column>
                            <Column field="submittedOn" header="Submitted On" filter filterPlaceholder="Search" sortable style={{ minWidth: '5rem' }}></Column>
                            <Column header="Status" field="status" filter filterElement={statusRowFilterTemplate} body={TaskStatusSLA} sortable style={{ minWidth: '8rem' }}></Column>
                            <Column field="remark" header="Remarks" align='center' filter filterPlaceholder="Search" style={{ minWidth: '6rem' }}></Column>
                            <Column field="action" header="Action" align='center' body={initiateReportAction} style={{ minWidth: '6rem' }}></Column>
                          </DataTable>


                        </div>
                      </TabPanel> : null
                  }

                  {
                    (sixPeriodIsApprover == 1) ?
                      <TabPanel header="Requested Reports">
                        <div className={approvalReportRequestList.length === 0 ? "datatableemptymessage arrowhide" : "initiator  arrowshow"}>
                          <DataTable className="custpaginator custIcons custmBtnTable custTable" scrollable
                            value={approvalReportRequestList}
                            paginator rowsPerPageOptions={[10, 20, 30]} responsiveLayout="scroll" filters={filters} filterDisplay="row" paginatorTemplate="PrevPageLink PageLinks NextPageLink" rows={11}
                          // selectionMode='checkbox' selection={selectedReports} onSelectionChange={(e) => setSelectedReports(e.value)} dataKey="srNo"
                          >
                            {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column> */}
                            <Column field="SL" header="SL#" style={{ minWidth: '3rem' }} body={(data, options) => options.rowIndex + 1}></Column>
                            {/* <Column field="assignmentTitle" header="Assignment Title" filter filterPlaceholder="Search" sortable style={{ minWidth: '5rem' }}></Column> */}
                            <Column field="dates" header="Dates" filter filterPlaceholder="Search" sortable></Column>
                            <Column field="submittedOn" header="Submitted on" sortable filter filterPlaceholder="Search" style={{ minWidth: '5rem' }}></Column>
                            <Column field="Status" header="Status" body={requestReportStatus} filter filterElement={statusRowFilterTemplate} sortable style={{ minWidth: '8rem' }}></Column>
                            <Column field="remark" header="Remarks" sortable filter filterPlaceholder="Search" style={{ minWidth: '5rem' }}></Column>
                            <Column field="action" header="Action" align='center' body={requestedReportAction} style={{ minWidth: '6rem' }}></Column>
                          </DataTable>
                        </div>
                      </TabPanel> : null
                  }

                </TabView>


                <Dialog className="relative reports-popup" visible={visible} position={position}
                  style={{ width: '60vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisible(false)} draggable={false} resizable={false}>
                  <div className="grid grid-cols-1 lg:grid-cols-12">
                    <div className="col-span-1 lg:col-span-12 bg-[#F5F6F7] h-auto">
                      <div className="p-5">
                        <div onClick={() => setVisible(false)} className="py-3">
                          <Image src={sideBarRight} alt="user" width="24" height="24" /></div>

                        {
                          (!fullViewForView) ?
                            <div>
                              <div className='text-center'>
                                <div className="text-[#000000] text-md lg:text-[0.833vw] font-bold">GLENDALE UNIFIED SCHOOL DISTRICT</div>
                                <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Request For Approval - Sixth Period Teaching Assignment</div>
                              </div>

                              <div className='pt-3'>
                                <p>Approval Status</p>
                                <div className="py-3 emp-simple-tbl">
                                  <DataTable
                                    className="custpaginator custIcons custmBtnTable custTable"
                                    value={specificReportDetailsView.approvalFinalData}

                                  >
                                    <Column field="empCode" header="Title"></Column>
                                    <Column field="empName" header="Name"></Column>
                                    <Column field="status" body={approvalStatusBody} header="Status"></Column>
                                  </DataTable>
                                </div>
                              </div>
                            </div> : null
                        }


                        <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">

                          <div className='flex justify-between'>
                            <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-file-icon"></i>Sixth Period Teaching Assignment.pdf</div>
                            <button onClick={() => { (!fullViewForView) ? setFullViewForView(true) : setFullViewForView(false) }} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>{(!fullViewForView) ? 'View Full Screen' : 'Exit Full Screen'} </button>
                          </div>

                          <div className="grid grid-cols-1">
                            {/* <img src={pdfImage} alt='myImg' /> */}

                            <HtmlToPdf
                              data={{
                                'employeeName': specificReportDetailsView.employeeName,
                                'employeeId': specificReportDetailsView.employee_id,
                                'schoolName': specificReportDetailsView.assighment_at,
                                'dateFrom': specificReportDetailsView.from_date,
                                'dateTo': specificReportDetailsView.to_date,
                                'subjectName': specificReportDetailsView.subject_area,
                                'staffAllocation': specificReportDetailsView.total_staffing_allocation,
                                'accountCharged': specificReportDetailsView.account_charged,
                                'fteUtilized': specificReportDetailsView.current_fte_utilized
                              }}
                            />
                          </div>
                        </div>




                        {/* <div className='grid grid-cols-2 gap-4'>
                                                <div className="bg-white border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                    <i className="mr-3 gusd-print-outline"></i><span>Print</span>
                                                </div>

                                                <div className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#fff] flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                    <i className="mr-3 gusd-print-outline"></i><span>Download</span>
                                                </div>
                                            </div> */}


                      </div>
                    </div>
                    {/* <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto">
                                        <div className="p-5">
                                            <div className="text-[#344054] text-[16px] font-medium py-3">Form History</div>
                                            <div>
                                                <div className="text-[#000000] text-[12px] font-normal text-center py-2 separator">Yesterday</div>

                                                {
                                                    (specificReportDetailsView.formHistoryFinalData) ?

                                                        (specificReportDetailsView.formHistoryFinalData.map((currentItem) => {
                                                            return (
                                                                <div className="flex items-start justify-between gap-2 py-2">
                                                                    <Image src={user1} alt="user" width="32" height="32" />
                                                                    <div className="">
                                                                        <div className="flex justify-between">
                                                                            <div>
                                                                                <div className="text-[#344054] font-semibold text-[14px]">{currentItem.empName}</div>
                                                                                <div className="text-[#667085] text-[10px] pb-2 pt-1">
                                                                                    <i className="mr-1 gusd-commented"></i>
                                                                                    <span>{currentItem.remarkType}</span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="text-[#344054] text-[12px]">09:00</div>
                                                                        </div>
                                                                        <div className="text-[#344054] text-[12px] font-normal p-[8px] bg-[#F5F6F7] rounded-[8px]">{currentItem.empRemark}</div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        }))
                                                        : null
                                                }
                                            </div>
                                        </div>
                                    </div> */}
                  </div>
                </Dialog>

                {/* edit popup for initiate request start */}
                < Dialog className="relative reports-popup" visible={visibleEdit} position="right" style={{ width: `${(fullViewEdit) ? '50vw' : '30vw'}` }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleEdit(false)} draggable={false} resizable={false} >
                  <div className="">
                    <div className="bg-[#F5F6F7] relative h-screen">
                      <div className="p-5">
                        <a to='' onClick={() => setVisibleEdit(false)} className="py-3"><Image
                          src={sidebar} alt="user" width="24" height="24" /></a>


                        {
                          (!fullViewEdit) ?
                            <div>
                              <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">6th Period Teaching Assignment</div>
                              <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Sixth Period Teaching Assignment - Classified form</div>
                              <div className="bg-white px-2 rounded-[8px] mt-3">
                                <div className="mb-1">
                                  <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">Approval Status</label>
                                  <div className="emp-simple-tbl">
                                    <DataTable
                                      className="custpaginator custIcons custmBtnTable custTable"
                                      value={specificReportDetailsEdit.approvalFinalData}
                                    >
                                      <Column field="empCode" header="Title"></Column>
                                      <Column field="empName" header="Name"></Column>
                                      <Column field="status" header="Status" body={approvalStatusBody}></Column>
                                    </DataTable>
                                  </div>
                                </div>
                              </div>
                            </div> : null
                        }



                        <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">

                          {
                            (!fullViewEdit) ?
                              <div className='flex justify-between'>
                                <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Sixth Period.pdf</div>
                                <button onClick={() => setFullViewEdit(true)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>View Full Screen</button>
                              </div> :
                              <div className='flex justify-between'>
                                <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Sixth Period Teaching Assignment.pdf</div>
                                <button onClick={() => setFullViewEdit(false)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>Exit Full Screen</button>
                              </div>
                          }

                          {
                            (!fullViewEdit) ?
                              <div className="grid grid-cols-1 border border-[red] h-80 overflow-hidden">
                                {/* <img src={pdfImageForEdit} alt='myImg' /> */}
                                <HtmlToPdf
                                  data={{
                                    'employeeName': specificReportDetailsEdit.employeeName,
                                    'employeeId': specificReportDetailsEdit.employee_id,
                                    'schoolName': specificReportDetailsEdit.assighment_at,
                                    'dateFrom': specificReportDetailsEdit.from_date,
                                    'dateTo': specificReportDetailsEdit.to_date,
                                    'subjectName': specificReportDetailsEdit.subject_area,
                                    'staffAllocation': specificReportDetailsEdit.total_staffing_allocation,
                                    'accountCharged': specificReportDetailsEdit.account_charged,
                                    'fteUtilized': specificReportDetailsEdit.current_fte_utilized
                                  }}
                                />
                              </div> :
                              <div className='mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw] overflow-y-auto' style={{ height: '580px' }}>
                                {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}
                                <HtmlToPdf
                                  data={{
                                    'employeeName': specificReportDetailsEdit.employeeName,
                                    'employeeId': specificReportDetailsEdit.employee_id,
                                    'schoolName': specificReportDetailsEdit.assighment_at,
                                    'dateFrom': specificReportDetailsEdit.from_date,
                                    'dateTo': specificReportDetailsEdit.to_date,
                                    'subjectName': specificReportDetailsEdit.subject_area,
                                    'staffAllocation': specificReportDetailsEdit.total_staffing_allocation,
                                    'accountCharged': specificReportDetailsEdit.account_charged,
                                    'fteUtilized': specificReportDetailsEdit.current_fte_utilized
                                  }}
                                />
                              </div>
                          }
                        </div>
                      </div>



                      <div className="absolute  bottom-2 left-2 right-2 grid grid-cols-2 gap-2 ">

                        <Link to='#' className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                          //  onClick={() => setVisibleCreteReportPopup(false)}
                          onClick={() => setConfirmVisible(true)}
                        ><i className="pi pi-save mr-1" style={{ fontSize: '1rem' }}></i>Save</Link>

                        <Link to='' className=" text-center flex items-center tableBtn blue radius8"
                          //  onClick={() => saveGroupInfo()}
                          onClick={() => {
                            onSubmitFunction(specificReportDetailsEdit.id, specificReportDetailsEdit.empID)
                            setConfirmVisible(true)
                          }
                          }
                        ><i className="pi pi-check mr-1" style={{ fontSize: '1rem' }}></i>Submit</Link>

                      </div>
                    </div>
                  </div>
                </Dialog >

                {/* confirmation dialog */}
                <Dialog header="" visible={confirmVisible} style={{ width: '30vw' }} onHide={() => { setConfirmVisible(false); setVisibleEdit(false); }} footer={footerContent}>
                  <p className="m-0 text-[#0487C8]">
                    <i className='pi pi-check-circle mr-2'></i>
                    <span className='font-medium text-[18px]'>Your changes has been saved in this report</span>
                  </p>
                </Dialog>
                {/* edit popup end */}

                {/* edit popup for requested report start */}
                < Dialog className="relative reports-popup" visible={visibleRequestedReportEdit} position="right" style={{ width: `${(fullViewEdit) ? '50vw' : '30vw'}` }
                } breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleRequestedReportEdit(false)} draggable={false} resizable={false} >
                  <div className="">
                    <div className="bg-[#F5F6F7] relative h-screen">
                      <div className="p-5">
                        <a to='' onClick={() => setVisibleRequestedReportEdit(false)} className="py-3"><Image
                          src={sidebar} alt="user" width="24" height="24" /></a>

                        {
                          (!fullViewEdit) ?
                            <div>
                              <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">6th Period Teaching Assignment</div>
                              <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Sixth Period Teaching Assignment - Classified form</div>
                              <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                                <div className="mb-1">
                                  <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">Approval Status</label>
                                  <div className="py-3 emp-simple-tbl">
                                    <DataTable
                                      className="custpaginator custIcons custmBtnTable custTable"
                                      value={specificReportDetailsEdit.approvalFinalData}
                                    >
                                      <Column field="empCode" header="Title"></Column>
                                      <Column field="empName" header="Name"></Column>
                                      <Column field="status" body={approvalStatusBody} header="Status"></Column>
                                    </DataTable>
                                  </div>
                                </div>
                              </div>
                            </div> : null
                        }



                        <div className="bg-[#EFF0F1] rounded-[8px] p-3 mt-3">

                          {
                            (!fullViewEdit) ?
                              <div className='flex justify-between'>
                                <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Sixth Period.pdf</div>
                                <button onClick={() => setFullViewEdit(true)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>View Full Screen</button>
                              </div> :
                              <div className='flex justify-between'>
                                <div className="text-[#344054] font-medium text-[20px] pb-3"><i className="mr-3 gusd-document"></i>Sixth Period Teaching Assignment.pdf</div>
                                <button onClick={() => setFullViewEdit(false)} className="text-[#113699] font-medium text-[14px] pb-3"><i className="pi pi-calendar mr-1 mt-2"></i>Exit Full Screen</button>
                              </div>
                          }


                          {
                            (!fullViewEdit) ?
                              <div className="grid grid-cols-1 border border-[red] h-80 overflow-hidden">
                                {/* <img src={pdfImageForEdit} alt='myImg' /> */}
                                <HtmlToPdf

                                  data={{
                                    'employeeName': specificReportDetailsEdit.employeeName,
                                    'employeeId': specificReportDetailsEdit.employee_id,
                                    'schoolName': specificReportDetailsEdit.assighment_at,
                                    'dateFrom': specificReportDetailsEdit.from_date,
                                    'dateTo': specificReportDetailsEdit.to_date,
                                    'subjectName': specificReportDetailsEdit.subject_area,
                                    'staffAllocation': specificReportDetailsEdit.total_staffing_allocation,
                                    'accountCharged': specificReportDetailsEdit.account_charged,
                                    'fteUtilized': specificReportDetailsEdit.current_fte_utilized
                                  }}
                                />
                              </div> :
                              <div className='mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw] overflow-y-auto' style={{ height: '580px' }}>
                                {/* <img src={pdfImageReport} alt='pdfImageReport' /> */}
                                <HtmlToPdf
                                  data={{
                                    'employeeName': specificReportDetailsEdit.employeeName,
                                    'employeeId': specificReportDetailsEdit.employee_id,
                                    'schoolName': specificReportDetailsEdit.assighment_at,
                                    'dateFrom': specificReportDetailsEdit.from_date,
                                    'dateTo': specificReportDetailsEdit.to_date,
                                    'subjectName': specificReportDetailsEdit.subject_area,
                                    'staffAllocation': specificReportDetailsEdit.total_staffing_allocation,
                                    'accountCharged': specificReportDetailsEdit.account_charged,
                                    'fteUtilized': specificReportDetailsEdit.current_fte_utilized
                                  }}
                                />
                              </div>
                          }



                        </div>
                      </div>


                      <div className="dialogpoput card flex justify-between">

                        {signature ?
                          (!needMoreApprovals) ?

                            <div className='flex ml-2'>
                              <InputSwitch checked={checkedSignature} onChange={(e) => setCheckedSignature(e.value)} />
                              <span className="text-[#1E3E5A] text-[16px] font-semibold  pl-2">Add e Signature</span>
                            </div>
                            :
                            (selectedEmployeeForApprovals) ?
                              <div className='flex ml-2'>
                                <InputSwitch checked={checkedSignature} onChange={(e) => setCheckedSignature(e.value)} />
                                <span className="text-[#1E3E5A] text-[16px] font-semibold  pl-2">Add e Signature</span>
                              </div> : null : null
                        }


                        {
                          (needMoreApprovals) ?
                            <div className='flex'>
                              <button onClick={() => setShowNeedMoreApprovals(true)}>Need More Approvals ?</button>
                              {
                                (showNeedMoreApprovals) ?
                                  <Dropdown value={selectedEmployeeForApprovals} onChange={(e) => setSelectedEmployeeForApprovals(e.value)} options={employeeList} optionLabel="name"
                                    placeholder="Select" className="w-36 md:w-14rem" /> : null
                              }
                            </div> : <div></div>
                        }

                      </div>
                      <div className="absolute mb-10 bottom-2 left-2 right-2 grid grid-cols-3 gap-2 ">

                        <Link to='#' onClick={() => setVisibleRequestedReportEdit(false)} className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
                        //  onClick={() => setVisibleCreteReportPopup(false)}
                        // onClick={() => setConfirmVisible(true)}
                        ><i className="gusd-close-circle mr-1" style={{ fontSize: '1rem' }}></i>Cancel</Link>

                        {
                          (!checkedSignature) ?
                            <Link to='' className="bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center text-[#D92D20]"
                              //  onClick={() => saveGroupInfo()}
                              onClick={() =>
                                setRejectVisible(true)
                              }
                            ><i className="gusd-close mr-1" style={{ fontSize: '1rem' }}></i>Reject</Link> :
                            <button disabled className=" text-center flex items-center tableBtn bg-[#E4E7EC] border border-[#D0D5DD] radius8"
                            ><i className="pi gusd-close mr-1" style={{ fontSize: '1rem' }}></i>Reject</button>
                        }


                        {
                          (!checkedSignature) ?
                            <button disabled className=" text-center flex items-center tableBtn bg-[#E4E7EC] border border-[#D0D5DD] radius8"
                            ><i className="pi pi-check mr-1" style={{ fontSize: '1rem' }}></i>Approve</button>
                            : <button onClick={() => approveSelectedReport(specificReportDetailsEdit.id)} className="text-center flex items-center tableBtn bg-white text-[#039855] border border-[#D0D5DD] radius8"
                            ><i className="pi pi-check mr-1" style={{ fontSize: '1rem' }}></i>Approve</button>
                        }


                      </div>
                    </div>
                  </div>
                </Dialog >
                <Dialog header="" visible={requestApprovalConfirmVisible} style={{ width: '30vw' }} onHide={() => { setRequestApprovalConfirmVisible(false); setVisibleEdit(false); }} footer={footerContentForReqApproval}>
                  <p className="m-0 text-[#0487C8] text-center">
                    <i className='pi pi-check-circle mr-2'></i>
                    <span className='font-medium text-[18px]'>This report was Approved</span>
                  </p>
                </Dialog>

                {/* Reject dialog */}
                <Dialog header="Reject Report" visible={rejectVisible} style={{ width: '30vw' }} onHide={() => {
                  setRejectVisible(false);
                  // setVisibleEdit(false);
                }} footer={footerContentForReqReject}>
                  <div className="m-0">
                    {
                      (!sendMsg) ?
                        <div className='font-medium text-[18px] mb-6'>Enter the Reason for Rejection<span className="text-[red] pl-0.2">*</span></div>
                        :
                        <div className='font-medium text-[18px] text-[#249144] mb-6'>Message Sent Successfully</div>
                    }
                    <InputText value={rejectMsgValue} placeholder="Enter the Reason for Rejection" onChange={(e) => setRejectValueMsg(e.target.value)} className="w-full" />
                  </div>
                </Dialog>
                {/* edit popup end */}
                {/* edit popup for requested report end */}




              </div>

              <Sidebar visible={visibleRight} position="right" onHide={() =>
                setVisibleRight(false)} style={{ width: '35vw' }} className="customesidebar1 responsivepoup ">
                <Editpopup popupstate={() => setVisibleRight(false)}
                  fromDate={fromDate}
                  toDate={toDate}
                  schoolName={schoolName}
                  reportEmployeeList={reportEmployeeList}
                  status={status}
                  reportId={reportId}
                  // bindList={() => loadAbsenceReport()}
                  type={"Initior"}
                />

              </Sidebar>
            </div>
          </div>
        </div >


        {/* popup's */}
        < Dialog className="relative reports-popup" visible={visibleCreteReportPopup} position="right" style={{ width: '30vw' }
        } breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setVisibleCreteReportPopup(false)} draggable={false} resizable={false} >
          <div className="">
            <div className="bg-[#F5F6F7] relative h-screen">
              <div className="p-5">
                <a to='' onClick={() => setVisibleCreteReportPopup(false)} className="py-3"><Image
                  src={sidebar} alt="user" width="24" height="24" /></a>
                <div className="text-[#113699] text-md md:text-[0.833vw] font-bold">6th Period Teaching Assignment</div>
                {/* <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Roles</div> */}
                <div className="py-3 bg-white px-5 rounded-[8px] mt-3">
                  <div className="mb-1">
                    <label className="text-[#344054] text-[0.729vw] font-medium pb-1" htmlFor="username">Assignment Title</label>
                    <div><InputText
                      value={groupName}
                      onChange={e => setGroupName(e.target.value)}
                      id="username" placeholder="Type Here" className="w-full placeholder:text-[#667085] " aria-describedby="username-help" /></div>
                  </div>
                </div>
              </div>
              <div className="absolute  bottom-2 left-2 right-2 grid grid-cols-2 gap-2 ">

                <Link to='#' className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center" onClick={() => setVisibleCreteReportPopup(false)}><i className="pi pi-times mr-1" style={{ fontSize: '1rem' }}></i>Cancel</Link>

                <Link to='' className=" text-center flex items-center tableBtn blue radius8" onClick={() => {
                  setShowNextPopUp(true);
                  // saveGroupInfo();
                }}><i className="pi pi-arrow-right mr-1" style={{ fontSize: '1rem' }}></i>Next</Link>

              </div>
            </div>
          </div>
        </Dialog >


        {/*Initiate New Report popup */}
        < Dialog className="relative reports-popup" visible={showNextPopUp} position="right" style={{ width: '100vw' }
        } breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => setShowNextPopUp(false)} draggable={false} resizable={false} >


          {/* <div class="p-10"><a href="#" id="add-family-open-btn"><i class="gusd-edit text-2xl"></i></a></div> */}
          <div className="fixed z-10 inset-0 overflow-y-auto styled-select" >

            <div className="flex items-start justify-center min-h-full h-full bg-[#FBFDFF]">
              <div className="relative overflow-hidden transform transition-all w-full">
                <div className="grid grid-cols-12 custmCols">
                  <div className="col-span-3 h-full sideBarLeft openSideDiv">
                    <button onClick={() => { setShowPreviewPopUp(false); setShowNextPopUp(false) }} type="button" className="inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-[#2D5BE5] text-[14px] xl:text-[0.729vw] font-medium bg-[#EFF8FF] border border-[#EFF8FF] rounded-md" id="add-family-cancel-btn"><i className="gusd-arrow-line-right mr-[14px] xl:mr-[0.729vw]"></i> Back Home</button>
                    <div className="mt-[16px] xl:mt-[0.833vw] text-[#101828] text-[14px] xl:text-[0.633vw] font-normal">GUSD 6th Period Teaching Assignment</div>
                    <div className="mt-[10px] xl:mt-[0.533vw] text-[#101828] text-[20px] xl:text-[0.833vw] font-medium">Assignment 10102</div>
                    <div className="mt-[32px] xl:[1.667vw]">
                      <ul className="sideTabs">
                        <li><a href="#" onClick={() => setShowPreviewPopUp(false)} className={`${(showPreviewPopUp) ? 'tab-b active ' : 'tab-b active activeCheck'}`} data-id="tab1">
                          <i className="gusd-check text-[16px] xl:text-[1.042vw]"></i>
                          Basic Info</a></li>
                        <li><a href="#"
                          // onClick={() => 
                          // setShowPreviewPopUp(true)
                          // }
                          className={`${(showPreviewPopUp) ? 'tab-b active activeCheck' : ''}`} data-id="tab2"><i className="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i> Preview & Edit</a></li>
                        {/* <li><a href="javascript:void(0);" class="tab-b" data-id="tab3"><i class="gusd-guardian-info text-[20px] xl:text-[1.042vw]"></i> Report Options</a></li> */}
                      </ul>
                    </div>
                    <div className="fixed top-0 left-0 openBtn xl:hidden">
                      <button type="button" className="sideDivBtn inline-flex justify-center py-[12px] xl:py-[0.625vw] px-[16px] xl:px-[0.833vw] text-white text-[14px] xl:text-[0.729vw] font-medium bg-[#3366FF] border border-[#EFF8FF] rounded-r-md"><i className="gusd-arrow-line-right"></i></button>
                    </div>
                  </div>

                  <div className="col-span-12 xl:col-span-6 
                                    mScrollCstm
                                    overflow-auto
                                    ">
                    <div className="tab-c tab-active p-lr-110 pt-10 xl:pt-0" data-id="tab1">
                      <div className="text-[24px] xl:text-[1.250vw] font-medium">{(showPreviewPopUp) ? 'Preview & Edit' : 'Basic Info'}</div>
                      <div className="mCustomScrollbar scroll-w-10 max-h-100">
                        {
                          (!showPreviewPopUp) ?
                            <div className="mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw]">
                              <form>
                                <div className="space-y-[32px] xl:space-y-[1.667vw]">

                                  <div className="col">
                                    <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Assignment Title<span className='text-[red] pl-0.2'>*</span></label>
                                    <InputText
                                      value={assignmentTitle ? assignmentTitle : propsAssighnmentTitle}
                                      onChange={e => setAssignmentTitle(e.target.value)}
                                      id="username" placeholder="Type Here" className="w-full placeholder:text-[#667085] " aria-describedby="username-help" />
                                  </div>


                                  <div>
                                    <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Employee ID<span className='text-[red] pl-0.2'>*</span></label>
                                    <Dropdown value={selectedEmployee ? selectedEmployee : propsSelectedEmployee}
                                      onChange={(e) => selectedEmployeeFunction(e)} options={empCodeList} optionLabel="name" placeholder="Select a Employee"
                                      filter
                                      // valueTemplate={selectedCountryTemplate}
                                      className="w-full md:w-14rem" />
                                  </div>

                                  <div className="col">
                                    <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Classification<span className='text-[red] pl-0.2'>*</span></label>
                                    <InputText
                                      value={classificationValue ? classificationValue : propsAssighnmentTitle}
                                      onChange={e => setClassificationValue(e.target.value)}
                                      id="username" placeholder="Type Here" className="w-full placeholder:text-[#667085] " aria-describedby="username-help" />
                                    {/* <input onChange={e => setAssignmentTitle(e.target.value)} type="text" name="" class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]" placeholder="Type here" /> */}
                                  </div>

                                  <div className="col">
                                    <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Dates<span className='text-[red] pl-0.2'>*</span></label>
                                    <div className="grid grid-cols-2 gap-4">
                                      <div className="relative custp-calender">
                                        <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                        <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                        <div className="card flex justify-content-center">
                                          <Calendar
                                            onChange={(e) => {
                                              setStartDate(e.target.value)
                                            }}
                                            value={startDate ? startDate : new Date(propsStartDate)}
                                            placeholder="Start Date"
                                            className="w-full h-11" />
                                        </div>
                                      </div>
                                      <div className="relative custp-calender">
                                        <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                        <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                        <div className="card flex justify-content-center">
                                          <Calendar
                                            onChange={(e) => {
                                              setEndDate(e.target.value)
                                            }}
                                            value={endDate ? endDate : new Date(propsEndDate)}
                                            minDate={startDate}
                                            placeholder="End Date"
                                            className="w-full h-11" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>


                                  <div className="col">
                                    <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Type of Sub Request/Object Code<span className='text-[red] pl-0.2'>*</span></label>
                                    <Dropdown id="dept" value={typeOfSubReqOrObjCodeValue ? typeOfSubReqOrObjCodeValue : propsSchoolSelect}
                                      onChange={(e) => {
                                        setTypeOfSubReqOrObjCodeValue(e.target.value)
                                      }}
                                      options={typeOfSubReqOrObjCodeList} optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC]" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                    />
                                  </div>

                                  <div className="col">
                                    <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Total Working Hourse<span className='text-[red] pl-0.2'>*</span></label>
                                    <InputText
                                      type='number'
                                      value={totalWorkingHoursValue ? totalWorkingHoursValue : propsAssighnmentTitle}
                                      onChange={e => setTotalWorkingHoursValue(e.target.value)}
                                      id="username" placeholder="Type Here" className="w-full placeholder:text-[#667085] " aria-describedby="username-help" />
                                    {/* <input onChange={e => setAssignmentTitle(e.target.value)} type="text" name="" class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]" placeholder="Type here" /> */}
                                  </div>




                                  <div className="col">
                                    <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Time<span className='text-[red] pl-0.2'>*</span></label>
                                    <div className="grid grid-cols-2 gap-4">
                                      <div className="relative custp-calender">
                                        <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                        <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                        <div className="card flex justify-content-center">


                                          <Calendar id="calendar-timeonly" value={startTime} onChange={(e) => setStartTime(e.value)} timeOnly placeholder="Start Time" className="w-full h-11" />

                                        </div>
                                      </div>

                                      <div className="relative custp-calender">
                                        <i className="gusd-calendar text-[#667085] text-sm absolute left-[0.8rem] top-[0.8rem] z-10"></i>
                                        <i className="gusd-arrow-down text-[#344054] text-xs xl:text-[0.7rem] absolute right-[1.4rem] top-[1.0rem] z-10"></i>
                                        <div className="card flex justify-content-center">

                                          <Calendar id="calendar-timeonly" value={endTime} onChange={(e) => setEndTime(e.value)} timeOnly placeholder="End Time" className="w-full h-11" />

                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col">
                                    <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Location<span className='text-[red] pl-0.2'>*</span></label>
                                    <Dropdown
                                      value={location}
                                      onChange={(e) => {
                                        setLocation(e.value);
                                      }}
                                      options={locationList}
                                      optionLabel="name"
                                      placeholder="Select Location"
                                      filter
                                      className="w-full md:w-14rem" />
                                  </div>

                                  <div className="col">
                                    <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Reason for Absence/Request</label>
                                    <input value={reasonForAbsenceReqValue ? reasonForAbsenceReqValue : propsTotalStaffingAllocationectedRole} onChange={e => setReasonForAbsenceReqValue(e.target.value)} type="text" name="" class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw]" placeholder="Type here" />
                                  </div>

                                  <div className="col">
                                    <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Substitute<span className='text-[red] pl-0.2'>*</span></label>
                                    <InputText
                                      value={substituteValue ? substituteValue : propsAssighnmentTitle}
                                      onChange={e => setSubstituteValue(e.target.value)}
                                      id="username" placeholder="Type Here" className="w-full placeholder:text-[#667085] " aria-describedby="username-help" />
                                  </div>

                                  <div className="col">
                                    <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Confirmed<span className='text-[red] pl-0.2'>*</span></label>
                                    <div className="card flex justify-content-center">
                                      <div className="flex gap-x-2">
                                        <div className="flex align-items-center">
                                          <RadioButton inputId="confirmValue1" name="confirmed" value="Yes" onChange={(e) => seConfirmedValue(e.value)} checked={confirmedValue === 'Yes'} />
                                          <label htmlFor="confirmValue1" className="ml-2">Yes</label>
                                        </div>
                                        <div className="flex align-items-center">
                                          <RadioButton inputId="confirmValue2" name="confirmed" value="No" onChange={(e) => seConfirmedValue(e.value)} checked={confirmedValue === 'No'} />
                                          <label htmlFor="confirmValue2" className="ml-2">No</label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>


                                  <div className='col mt-2'>
                                    <div className="col">
                                      <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Account Number(s) To Be Charged<span className='text-[red] pl-0.2'>*</span></label>
                                      {
                                        accountNoArray.map((item, index) => {
                                          return (
                                            <input value={item.accountNo} onChange={e => { onChangeAccNo(index, e.target.value) }} name="" class="text-[16px] xl:text-[0.833vw] px-[14px] py-[10px] bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] placeholder-[#101828] focus:outline-none focus:border-[#D0D5DD] focus:ring-[#D0D5DD] block w-full rounded-[8px] xl:rounded-[0.417vw] mt-2" placeholder="Type here" />
                                          )
                                        })
                                      }
                                    </div>
                                    <a href="#" onClick={() => {
                                      onClickAdd();
                                    }} className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] mt-2">
                                      Add</a>
                                  </div>



                                  <div className="col">
                                    <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Principle/Departament Head (First_Approveal)</label>
                                    <Dropdown id="dept" value={firstApproval ? firstApproval : propsSchoolSelect}
                                      onChange={(e) => {
                                        setFirstApproval(e.target.value)
                                      }}
                                      options={approvalOneList} optionLabel="name" placeholder="Select" className="w-full h-11 rounded-md border border-[#E4E7EC]" style={{ fontSize: '0.875rem', color: '#667085', fontWeight: '400' }}
                                    />
                                  </div>


                                </div>
                              </form>
                            </div>

                            :
                            <div className='mt-[24px] xl:mt-[1.250vw] pb-[40px] xl:pb-[2.083vw]'>
                              <div id="my-html-template" className='border px-8'>
                                <center><b>CLASSIFIED</b></center>
                                <center style={{ marginTop: '10px' }}>GLENDALE UNIFIED SCHOOL DISTRICT
                                  <div>Glendale, California</div>
                                  <div style={{ marginTop: '20px' }}><b>ADVANCE REQUEST FOR CLASSIFIED SUBSTITUTE</b></div>

                                  <div className='border w-2/4 text-[12px] mt-4'>
                                    DIRECTIONS:This form is to be completed and routed according to the approval signature(s) sequence below when requesting a Classified Substitute.
                                  </div>
                                </center>
                                <div className='mt-8'>

                                  <div className='leading-10'>
                                    <div className='flex justify-between'>
                                      <p>CLASSIFICATION <span className='text-[green] font-bold'>{classificationValue}</span></p> <p>DATES From: <span className='text-[green] font-bold'>{moment(startDate).format("YYYY-DD-MM")}</span> To Date: <span className='text-[green] font-bold'>{moment(endDate).format("YYYY-DD-MM")}</span></p></div>
                                    <p>Type of Sub Request/Object Code: <span className='text-[green] font-bold'>{typeOfSubReqOrObjCodeValue.name}</span></p>
                                    <p>Absent Employee's Legal Name (if applicable) <span className='text-[green] font-bold'>{selectedEmployee.name}</span></p>

                                    <div className='flex justify-between'>
                                      <p>Total Working Hours <span className='text-[green] font-bold'>{totalWorkingHoursValue}</span></p>
                                      <p>From <span className='text-[green] font-bold'>{moment(startTime).format("HH-MM")}</span> To <span className='text-[green] font-bold'>{moment(endTime).format("HH-MM")}</span></p>
                                    </div>
                                    <p>Location <span className='text-[green] font-bold'>{location.name}</span></p>
                                    <p>Reason For Absence/Request <span className='text-[green] font-bold'>{reasonForAbsenceReqValue}</span></p>
                                    <p>If possible, we would like to have ________________________________________________________________________</p>
                                  </div>

                                  <div className='mt-8 w-2/4 border'>
                                    <div className='font-bold text-center'>Account Number(s) To Be Charged</div>
                                    <p>________________________________________________________________________</p>
                                    <p>________________________________________________________________________</p>
                                    <p>________________________________________________________________________</p>
                                    <p>________________________________________________________________________</p>
                                  </div>

                                </div>
                              </div>
                            </div>
                        }

                      </div>

                      <div className="grid grid-cols-2 mt-[40px] xl:mt-[2.083vw]">
                        <div>
                          <a href="#" onClick={() => (showPreviewPopUp) ? setShowPreviewPopUp(false) : null} className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"><i className='gusd-arrow-line-right mr-1'></i>Previous</a>
                        </div>
                        <div className="flex justify-end space-x-[20px] xl:space-x-[1.042vw]">
                          {editMode ?
                            <a
                              onClick={() => {
                                saveBasicEditInfo('save', currentStatus);
                                setShowPreviewPopUp(false);
                              }}
                              href="javascript:void(0);" className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#26be13] hover:bg-[#23a512] border border-[#26be13] hover:border-[#23a512] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"><i className='pi pi-save mr-1' style={{ fontSize: '0.8rem' }}></i>Save</a>
                            :
                            <a
                              onClick={() => {
                                saveBasicInfo('save');
                                setShowPreviewPopUp(false);
                              }}
                              href="javascript:void(0);" className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#26be13] hover:bg-[#23a512] border border-[#26be13] hover:border-[#23a512] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw]"><i className='pi pi-save mr-1' style={{ fontSize: '0.8rem' }}></i>Save</a>}
                          {
                            (showPreviewPopUp) ?
                              <a href="#"
                                onClick={() => {
                                  saveBasicInfo('submit');
                                  setConfirmVisible2(true)
                                  // setShowPreviewPopUp(true)
                                }}
                                className="inline-block text-white text-[16px] xl:text-[0.833vw] font-medium bg-[#113699] hover:bg-[#0f296e] border border-[#113699] hover:border-[#0f296e] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] ">
                                <i className='gusd-check mr-1'></i>Submit</a> :
                              !editMode ?
                                <a href="#" onClick={() => {
                                  //first we check mandatory fields are filled or not

                                  if (assignmentTitle === '') { toast.error('Please enter Assighment Title'); return; }
                                  else if (selectedEmployee === null && selectedEmployee == '') { toast.error('Please Select Employee Id'); return; }
                                  else if (classificationValue === '') { toast.error('Please Enter Classification Value'); return; }
                                  else if (startDate === null) { toast.error('Please select Start Date'); return; }
                                  else if (endDate === null) { toast.error('Please enter End Date'); return; }
                                  else if (typeOfSubReqOrObjCodeValue === null) { toast.error('Please select type of sub req code'); return; }
                                  else if (totalWorkingHoursValue === '') { toast.error('Please enter total work hours'); return; }
                                  else if (startTime === null) { toast.error('Please select start time'); return; }
                                  else if (endTime === null) { toast.error('Please select End time'); return; }
                                  else if (location === null) { toast.error('Please select location'); return; }
                                  else if (reasonForAbsenceReqValue === '') { toast.error('Please enter reason for Absence'); return; }
                                  else if (substituteValue === '') { toast.error('Please enter Substitute'); return; }
                                  else if (confirmedValue === '') { toast.error('Please Confirm'); return; }
                                  else if (firstApproval === null) { toast.error('Please Select Approval'); return; }



                                  setShowPreviewPopUp(true)
                                }} className="inline-block text-[#344054] text-[16px] xl:text-[0.833vw] font-medium bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD] rounded-[8px] xl:rounded-[0.417vw] py-[10px] xl:py-[0.521vw] px-[18px] xl:px-[0.938vw] ">
                                  <i className='gusd-eye mr-1'></i>Preview</a>
                                : null
                          }
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* confirmation dialog */}

                  <Dialog header="" visible={confirmVisible2} style={{ width: '30vw' }} onHide={() => { setConfirmVisible2(false); setVisibleEdit(false); }} footer={footerContent1}>
                    <p className="m-0 text-[#0487C8]">
                      <i className='pi pi-check-circle mr-2'></i>
                      <span className='font-medium text-[18px]'>This report Has been Successfully  Created</span>
                    </p>
                  </Dialog>

                  <div className="col-span-3 sideBarRight openSideDiv">
                    <div className="h-full relative">
                      <div className="text-[24px] xl:text-[1.250vw] font-medium">Employee Details</div>
                      <div className="mt-[15px] lg:mt-[32px] xl:[1.667vw]">

                        {
                          (selectedEmployee) ?
                            <div className='bg-[#D8E7FC] border border-[#D8E7FC] grid grid-cols-12 gap-4'>
                              <Avatar className='col-span-3' image="/images/avatar/amyelsner.png" size="xlarge" shape="circle" />
                              <div className='col-span-7'>
                                <label className="text-[#344054] text-[14px] xl:text-[0.729vw] font-medium mb-[10px] xl:mb-[0.521vw] inline-block" for="username">Name</label>
                                <div className="text-[#101828] text-[12px] font-medium">{selectedEmployeeDetails.name}</div>
                              </div>
                              <i className='gusd-edit col-span-2'></i>
                            </div> : null
                        }




                        <div className="absolute bottom-[20px] left-0 right-0 xl:bottom-[2.083vw] -z-[1]">
                          <img src={empDetailsImg} class=" mx-auto" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </Dialog >



      </Layout >
    </>
  ) : (
    <Login sessionExpired={1} />
  );
}

export default ClassifiedSubstituteRequestReportList